var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "viewBox": "0 0 1773 978",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('title', [_vm._v("Demo - Landscape")]), _c('desc', [_vm._v("Downloaded from openclipart.org/detail/185885")]), _c('defs'), _c('g', {
    attrs: {
      "id": "g10",
      "transform": "matrix(2.784595, 0, 0, -2.683162, 847.502258, 1661.524902)"
    }
  }, [_c('g', {
    attrs: {
      "id": "g12",
      "transform": "scale(0.1)"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#7ad4f7",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -2019.535 4864.21 C -2002.465 5293.73 -1734.055 5729.46 -1320.985 5848.42 C -961.615 5951.9 -581.695 5808.95 -238.915 5659.41 C 103.845 5509.87 469.615 5347.54 837.845 5412.84 C 1170.445 5471.82 1439.615 5705.4 1718.275 5896.32 C 1996.935 6087.23 2345.525 6246.43 2664.085 6134.11 C 2844.215 6070.6 2987.035 5926.5 3085.385 5762.77 C 3320.885 5370.71 3312.805 4845.17 3065.375 4460.52 C 2817.935 4075.87 2343.045 3850.64 1888.615 3902.39 C 1707.995 3922.96 1527.185 3983.44 1348.195 3951.7 C 1093.915 3906.61 911.845 3691.24 709.475 3530.81 C 371.365 3262.78 -72.495 3132.03 -501.935 3173.98 C -1147.155 3237.01 -1683.575 3657.62 -1912.085 4256.13 C -1985.985 4449.7 -2027.785 4656.49 -2019.535 4864.21",
      "id": "path16"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#7ad4f7",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1584.955 5953.46 C 1611.645 5984.66 1637.105 6018.74 1646.725 6058.65 C 1656.355 6098.56 1646.535 6145.66 1613.425 6169.94 C 1582.165 6192.86 1539.135 6190.42 1501.405 6181.55 C 1368.535 6150.3 1149.115 5982.14 1204.145 5819.47 C 1273.095 5615.66 1520.545 5878.14 1584.955 5953.46",
      "id": "path18"
    }
  }), _c('path', {
    staticStyle: {
      "stroke": "rgb(255, 255, 255)",
      "stroke-width": "10",
      "stroke-linecap": "butt",
      "stroke-linejoin": "miter",
      "stroke-miterlimit": "10",
      "stroke-dasharray": "none",
      "stroke-opacity": "1",
      "fill": "rgb(98, 117, 32)"
    },
    attrs: {
      "d": "M -2088.585 3339.83 C -2094.625 3340.64 -2026.695 3348.69 -1993.665 3352.5 C -1993.355 3364.26 -1993.835 3376.03 -1995.135 3387.7 L -2121.605 3395.41 L -2005.825 3437.5 C -2011.415 3454.53 -2018.885 3470.91 -2028.285 3486.24 C -2049.095 3520.17 -2078.765 3550.32 -2087.145 3589.23 C -2096.705 3633.66 -2076.185 3678.69 -2053.505 3718.07 C -2030.845 3757.45 -2004.725 3797.44 -2001.795 3842.78 C -2000.035 3869.87 -2006.955 3896.2 -2018.135 3921.1 C -2046.125 3921.57 -2080.255 3921.67 -2098.525 3920.02 C -2106.595 3916.7 -2111.755 3915.15 -2111.545 3916.79 C -2111.345 3918.27 -2106.405 3919.31 -2098.525 3920.02 C -2083.145 3926.36 -2056.815 3939.41 -2033.895 3951.11 C -2038.435 3958.67 -2043.155 3966.11 -2048.115 3973.28 C -2074.905 4011.96 -2106.745 4047.67 -2126.555 4090.35 C -2146.485 4133.27 -2153.485 4181.71 -2176.905 4222.83 C -2200.325 4263.94 -2249.955 4297.19 -2293.795 4279.39 C -2335.035 4262.63 -2348.985 4211.01 -2348.835 4166.5 C -2348.805 4159.6 -2348.565 4152.65 -2348.275 4145.69 L -2287.215 4115.29 L -2347.035 4116.58 C -2346.085 4088.22 -2346.925 4060.17 -2358.195 4034.5 C -2378.885 3987.38 -2430.035 3959.72 -2452.976 3913.66 C -2481.554 3856.28 -2459.3 3787.11 -2430.663 3729.77 C -2421.523 3711.46 -2411.726 3693.04 -2402.597 3674.4 L -2302.775 3653.93 L -2386.605 3638.83 C -2375.165 3610.27 -2367.365 3580.93 -2368.395 3550.22 C -2371.255 3464.7 -2441.124 3393.79 -2449.995 3308.69 C -2450.234 3306.4 -2450.218 3304.27 -2450.39 3302.03 L -2332.675 3307.63 L -2449.206 3258.77 C -2423.816 3078.52 -2139.175 3080.32 -2040.695 3212.36 C -2016.135 3245.3 -2001.155 3284.63 -1995.785 3325.32 C -2026.905 3330.24 -2082.885 3339.08 -2088.585 3339.83 L -2088.585 3339.83 Z",
      "id": "path24"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#4998c4",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -2206.255 2888.77 C -2206.385 2888.77 -2206.525 2888.77 -2206.655 2888.78 C -2212.175 2889 -2216.465 2893.65 -2216.255 2899.16 C -2201.445 3279.24 -2263.115 4221.15 -2263.745 4230.62 C -2264.105 4236.13 -2259.935 4240.89 -2254.425 4241.25 C -2248.915 4241.56 -2244.145 4237.45 -2243.785 4231.93 C -2243.155 4222.45 -2181.425 3279.5 -2196.275 2898.38 C -2196.485 2893 -2200.915 2888.77 -2206.255 2888.77",
      "id": "path26"
    }
  }), _c('path', {
    staticStyle: {
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none",
      "fill": "rgb(71, 187, 97)"
    },
    attrs: {
      "d": "M -2328.955 3528.9 C -2308.525 3562.3 -2287.515 3595.35 -2267.845 3629.15 C -2287.925 3647.36 -2312.465 3662.32 -2336.055 3674.62 C -2372.485 3693.64 -2416.41 3703.48 -2443.402 3735.03 C -2492.351 3792.26 -2478.331 3871.79 -2518.519 3934.19 C -2536.285 3961.78 -2567.898 3975.15 -2597.796 3986.43 C -2609.437 3965.91 -2620.128 3945.45 -2632.077 3925.34 C -2628.574 3947.63 -2625.8 3970.01 -2622.82 3992.39 C -2633.523 3994.29 -2644.847 3996.18 -2655.613 3997.21 C -2707.816 4002.26 -2762.585 3998.57 -2813.304 4010.73 C -2855.589 4020.85 -2890.738 4046.74 -2931.374 4058.51 C -2972.015 4070.29 -3017.792 4067.43 -3037.097 4025.97 C -3053.206 3991.4 -3033.437 3953.89 -3010.41 3929.02 C -2987.374 3904.14 -2955.062 3892.84 -2930.98 3870.65 C -2906.898 3848.45 -2894.167 3823.33 -2882.956 3793.18 C -2851.202 3800.13 -2819.519 3807.74 -2787.718 3814.67 C -2816.077 3796.14 -2844.535 3778.52 -2873.476 3760.46 C -2858.538 3714.5 -2850.339 3670.61 -2811.671 3637.61 C -2769.964 3602.02 -2712.933 3602.82 -2666.199 3572.46 C -2610.745 3536.46 -2586.042 3478.92 -2569.081 3415.78 C -2567.702 3410.65 -2566.679 3405.24 -2565.531 3400.19 C -2546.429 3404.25 -2527.347 3408.57 -2508.16 3412.24 C -2525.699 3400.28 -2543.07 3388.22 -2560.714 3376.32 C -2550.179 3325.32 -2540.878 3276.13 -2516.566 3229.7 C -2505.183 3207.97 -2488.484 3191.54 -2471.874 3174.06 C -2446.222 3187.88 -2420.499 3201.06 -2394.695 3214.42 C -2411.152 3193.45 -2427.351 3172.67 -2443.964 3151.59 C -2430.355 3144.29 -2421.191 3135.04 -2405.327 3129.71 C -2364.185 3115.9 -2311.005 3088.68 -2266.265 3106.34 C -2161.955 3147.55 -2144.205 3291.39 -2149.905 3388.54 C -2154.765 3471.35 -2188.555 3526.06 -2231.675 3591.45 C -2264.805 3570.65 -2296.895 3550.46 -2328.955 3528.9",
      "id": "path28"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#4998c4",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -2233.775 2868.77 C -2239.085 2868.77 -2243.515 2872.96 -2243.755 2878.32 C -2243.905 2881.68 -2261.305 3217.98 -2477.413 3591.26 C -2692.292 3962.42 -3014.695 4020.86 -3017.929 4021.41 C -3023.367 4022.34 -3027.038 4027.49 -3026.12 4032.93 C -3025.202 4038.37 -3020.101 4042 -3014.609 4041.14 C -3011.288 4040.58 -2679.925 3980.96 -2460.113 3601.28 C -2241.405 3223.53 -2223.925 2882.62 -2223.775 2879.21 C -2223.525 2873.7 -2227.805 2869.03 -2233.315 2868.78 C -2233.475 2868.77 -2233.625 2868.77 -2233.775 2868.77",
      "id": "path30"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f9a729",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -2486.257 2970.43 C -2486.257 2970.43 -2495.206 2548.789 -2224.595 2550.43 C -1949.595 2552.101 -1977.925 2970.43 -1977.925 2970.43 L -2486.257 2970.43",
      "id": "path32"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f57f6a",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1585.155 3427.94 L -1575.775 2650.769 L -1524.815 2595.441 L -1419.025 2654.75 C -1394.725 2843.109 -1350.095 3149.01 -1314.725 3427.94 L -1585.155 3427.94",
      "id": "path34"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f9a729",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1609.925 2681.621 C -1612.035 2683.691 -1615.475 2682.601 -1616.155 2679.73 C -1619.065 2667.242 -1625.765 2639.172 -1633.205 2612.289 C -1641.055 2583.949 -1619.245 2561.879 -1609.625 2553.769 C -1606.955 2551.539 -1603.685 2550.422 -1600.205 2550.422 L -1196.325 2550.73 C -1196.325 2550.73 -1178.205 2578.5 -1308.625 2609.851 C -1439.055 2641.199 -1389.475 2679.148 -1429.865 2673.719 C -1470.255 2668.289 -1520.965 2613.289 -1560.155 2641.289 C -1587.165 2660.582 -1602.805 2674.711 -1609.925 2681.621",
      "id": "path36"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f57f6a",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1825.785 3427.94 C -1796.395 3139.49 -1760.905 2821.93 -1740.495 2634.82 L -1648.155 2586.269 L -1547.875 2649.441 L -1545.485 3427.94 L -1825.785 3427.94",
      "id": "path38"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1547.315 2678.351 C -1549.175 2728.359 -1549.935 2778.371 -1550.525 2828.371 C -1551.135 2878.37 -1550.855 2928.37 -1551.065 2978.38 C -1550.465 3028.37 -1550.295 3078.37 -1549.295 3128.37 L -1547.585 3203.36 C -1546.645 3228.36 -1546.055 3253.36 -1544.815 3278.35 C -1543.795 3253.35 -1543.405 3228.35 -1542.675 3203.34 L -1541.595 3128.34 C -1541.005 3078.33 -1541.255 3028.33 -1541.075 2978.33 C -1541.705 2928.33 -1541.835 2878.33 -1542.865 2828.34 C -1543.875 2778.34 -1545.045 2728.34 -1547.315 2678.351",
      "id": "path40"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f9a729",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1741.585 2681.621 C -1743.705 2683.691 -1747.145 2682.601 -1747.815 2679.73 C -1750.735 2667.242 -1757.435 2639.172 -1764.875 2612.289 C -1772.725 2583.949 -1750.915 2561.879 -1741.285 2553.769 C -1738.625 2551.539 -1735.355 2550.422 -1731.875 2550.422 L -1327.995 2550.73 C -1327.995 2550.73 -1309.865 2578.5 -1440.295 2609.851 C -1570.715 2641.199 -1521.145 2679.148 -1561.535 2673.719 C -1601.925 2668.289 -1652.625 2613.289 -1691.825 2641.289 C -1718.835 2660.582 -1734.475 2674.711 -1741.585 2681.621",
      "id": "path42"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1789.815 4382.11 C -1789.815 4382.11 -1892.315 4237.1 -1894.815 4044.6 C -1897.315 3852.1 -1822.315 3319.6 -1822.315 3319.6 L -1802.275 3314.03 C -1643.375 3269.78 -1475.155 3271.71 -1317.325 3319.6 L -1317.315 3319.6 C -1317.315 3319.6 -1169.815 4117.1 -1357.315 4377.11 L -1789.815 4382.11",
      "id": "path44"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1828.565 4184.6 C -1833.855 4149.13 -1837.515 4113.47 -1839.695 4077.74 C -1842.155 4042.03 -1843.055 4006.24 -1842.225 3970.52 C -1841.295 3934.77 -1838.935 3899.29 -1834.475 3863.63 L -1822.685 3756.71 L -1801.165 3542.69 L -1791.215 3435.59 C -1788.265 3399.85 -1784.965 3364.13 -1782.315 3328.35 C -1787.225 3363.89 -1791.485 3399.5 -1796.095 3435.06 L -1808.815 3541.9 L -1832.635 3755.76 L -1843.515 3862.78 C -1847.525 3898.32 -1850.165 3934.49 -1849.875 3970.44 C -1849.665 4042.4 -1842.955 4114.29 -1828.565 4184.6",
      "id": "path46"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f4715a",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -957.305 5113.43 C -963.245 5111.17 -974.355 5103.23 -992.675 5077.56 C -992.675 5077.56 -968.355 5139.92 -973.215 5150.98 C -978.075 5162.03 -1020.225 5087.17 -1020.225 5087.17 C -1020.225 5087.17 -1000.365 5160.17 -1008.415 5167.73 C -1016.455 5175.29 -1049.245 5096.48 -1049.245 5096.48 C -1049.245 5096.48 -1033.105 5172.87 -1039.495 5173.22 C -1055.385 5174.07 -1080.955 5067.4 -1091.865 5071.27 C -1101.535 5074.7 -1105.865 5101.43 -1105.715 5115.44 C -1105.675 5118.39 -1108.015 5120.58 -1110.975 5120.19 C -1116.785 5119.42 -1125.235 5115.74 -1126.375 5101.02 C -1127.835 5081.99 -1130.115 5044.53 -1116.265 5001.08 C -1116.285 5001.04 -1116.305 5001.01 -1116.315 5000.98 C -1120.825 4992.23 -1126.505 4981.21 -1133.055 4968.54 C -1118.535 4962.38 -1104.055 4956.29 -1089.585 4950.58 C -1071.675 4943.51 -1053.055 4935.45 -1033.985 4927.91 C -1031.315 4951.1 -1029.255 4974.4 -1028.005 4997.79 C -1028.005 4997.8 -1028.005 4997.81 -1028.005 4997.82 C -1001.605 5028.76 -961.165 5079.53 -952.785 5109.39 C -951.975 5112.27 -954.485 5114.51 -957.305 5113.43",
      "id": "path48"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f9a729",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1358.565 4998.36 C -1358.565 4998.36 -1302.315 4977.11 -1287.315 4940.86 C -1272.315 4904.61 -1239.815 4744.61 -1239.815 4744.61 L -1126.065 4992.11 L -1022.315 4968.36 C -1022.315 4968.36 -1041.065 4682.11 -1147.315 4488.36 C -1253.565 4294.6 -1387.315 4484.61 -1407.315 4553.36 C -1427.315 4622.11 -1466.065 4898.36 -1451.065 4925.86 C -1436.065 4953.36 -1358.565 4998.36 -1358.565 4998.36",
      "id": "path50"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1124.815 4957.11 C -1109.395 4956.95 -1094.785 4953.85 -1080.365 4950.05 C -1066.035 4945.95 -1051.895 4941.14 -1038.565 4933.36 C -1053.995 4933.49 -1068.605 4936.6 -1083.025 4940.41 C -1097.355 4944.53 -1111.495 4949.34 -1124.815 4957.11",
      "id": "path52"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f57f6a",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1403.695 5021.95 C -1418.695 5030.68 -1431.165 5039.66 -1441.645 5052.33 C -1444.105 5061.21 -1449.895 5083.18 -1454.245 5107.97 C -1458.065 5130.04 -1460.775 5154.28 -1458.865 5173.32 L -1458.865 5173.4 C -1457.985 5182.81 -1455.995 5190.94 -1452.405 5196.91 L -1666.005 5317.03 C -1665.845 5316.31 -1665.765 5315.67 -1665.605 5314.95 C -1662.225 5295.15 -1636.535 5139.85 -1662.805 5057.24 C -1671.735 5053.12 -1681.695 5049.59 -1693.125 5047.2 C -1637.795 4971.63 -1603.365 4883.81 -1547.185 4808.35 C -1516.565 4767.22 -1476.785 4723.05 -1420.715 4731.83 C -1415.215 4732.7 -1410.145 4733.95 -1405.315 4735.41 C -1398.645 4781.49 -1399.305 4831.41 -1398.935 4870.44 C -1398.495 4916.91 -1408.955 4972.33 -1403.695 5021.95",
      "id": "path54"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f3664f",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1454.245 5107.97 C -1570.365 5093.3 -1629.185 5231.99 -1631.335 5237.17 C -1609.905 5203.13 -1578.815 5185.92 -1548.455 5177.71 C -1511.065 5167.5 -1474.805 5170.93 -1459.585 5173.16 C -1459.335 5173.25 -1459.105 5173.25 -1458.865 5173.32 C -1460.775 5154.28 -1458.065 5130.05 -1454.245 5107.97",
      "id": "path56"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f9a729",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1665.655 5061.27 L -1495.655 4772.94 L -1439.815 5044.61 C -1439.815 5044.61 -1327.315 4992.94 -1300.655 4944.61 C -1273.985 4896.27 -1255.655 4777.94 -1268.985 4709.61 C -1282.315 4641.27 -1372.315 4429.61 -1343.985 4367.94 C -1315.655 4306.27 -1285.655 4237.94 -1280.655 4197.94 L -1382.315 4197.94 L -1422.315 4261.27 L -1452.315 4196.27 L -1887.315 4196.27 C -1887.315 4196.27 -1773.985 4437.94 -1768.985 4469.61 C -1763.985 4501.27 -1840.655 4782.94 -1845.655 4846.27 C -1850.655 4909.61 -1810.655 5019.61 -1783.985 5032.94 C -1757.315 5046.27 -1665.655 5061.27 -1665.655 5061.27",
      "id": "path58"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f8e160",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1665.655 5061.27 L -1679.815 4903.98 L -1613.155 4878.77 L -1659.815 4747.11 L -1498.565 4542.11 L -1385.655 4753.77 L -1413.985 4872.94 L -1326.485 4883.77 L -1440.455 5048.11 L -1495.655 4772.94 L -1665.655 5061.27",
      "id": "path60"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1665.655 5061.27 L -1507.945 4923.36 L -1439.815 5051.48 L -1333.985 4987.94 L -1399.815 4989.61 L -1495.655 4772.94 L -1656.695 4995.23 L -1722.315 4969.61 L -1665.655 5061.27",
      "id": "path62"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1652.315 4993.36 C -1646.885 4999.74 -1640.345 5003.27 -1633.525 5006.13 C -1626.595 5008.7 -1619.395 5010.59 -1611.065 5009.61 C -1616.495 5003.21 -1623.045 4999.68 -1629.865 4996.83 C -1636.805 4994.28 -1643.995 4992.4 -1652.315 4993.36",
      "id": "path64"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1399.815 4989.61 C -1410.575 4990.68 -1419.935 4994.48 -1428.975 4998.91 C -1437.865 5003.62 -1446.415 5008.99 -1453.565 5017.11 C -1442.805 5016.05 -1433.445 5012.26 -1424.415 5007.81 C -1415.535 5003.07 -1406.985 4997.7 -1399.815 4989.61",
      "id": "path66"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#de323f",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1284.715 4345.63 L -1636.865 4409.84 L -1542.285 4928.6 L -1190.135 4864.4 L -1284.715 4345.63",
      "id": "path68"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1277.845 4337.21 L -1630.005 4401.42 L -1535.425 4920.18 L -1193.375 4861.66 L -1181.025 4848.15 L -1277.845 4337.21",
      "id": "path70"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f1485b",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1270.925 4329.12 L -1623.085 4393.33 L -1528.505 4912.09 L -1176.345 4847.89 L -1270.925 4329.12",
      "id": "path72"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#de323f",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1176.345 4847.89 L -1190.135 4864.4 L -1193.375 4861.66 L -1181.695 4848.8 L -1176.345 4847.89",
      "id": "path74"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1802.315 4383.36 C -1802.315 4383.36 -1664.405 4421.27 -1630.655 4442.52 C -1630.655 4442.52 -1713.985 4332.1 -1826.485 4330.44 L -1802.315 4383.36",
      "id": "path76"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f57f6a",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1202.345 4707.92 C -1198.265 4719.29 -1280.355 4693.92 -1280.355 4693.92 C -1280.355 4693.92 -1215.735 4733.26 -1216.385 4744.29 C -1217.025 4755.31 -1295.025 4720.63 -1295.025 4720.63 C -1295.025 4720.63 -1230.775 4765 -1235.175 4769.64 C -1246.135 4781.19 -1338.035 4721.31 -1343.295 4731.63 C -1347.965 4740.77 -1332.725 4763.16 -1322.985 4773.23 C -1320.935 4775.34 -1321.125 4778.53 -1323.535 4780.29 C -1328.285 4783.73 -1336.955 4786.86 -1347.895 4776.96 C -1362.095 4764.11 -1389.565 4738.21 -1409.405 4696.9 C -1409.495 4696.87 -1409.465 4696.87 -1409.625 4696.84 C -1414.025 4695.26 -1445.765 4684.11 -1495.455 4666.81 C -1495.485 4661.82 -1495.455 4656.81 -1495.205 4651.8 C -1493.455 4615.26 -1490.245 4578.44 -1486.065 4542.11 C -1485.685 4538.77 -1485.175 4535.44 -1484.755 4532.11 C -1443.365 4562.86 -1403.485 4596.04 -1366.185 4632.2 L -1366.345 4632.44 L -1366.385 4632.51 C -1330.995 4635.69 -1247.415 4644.95 -1216.105 4663.68 C -1213.535 4665.21 -1213.825 4668.56 -1216.605 4669.72 C -1222.465 4672.16 -1235.995 4674.04 -1266.955 4668 C -1266.955 4668 -1206.415 4696.55 -1202.345 4707.92",
      "id": "path78"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f9a729",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1427.315 4695.86 L -1709.815 4599.61 C -1709.815 4599.61 -1686.605 4688.12 -1680.095 4785.11 C -1698.725 4791.88 -1715.815 4802.46 -1727.125 4817.7 C -1732.695 4825.19 -1736.115 4832.62 -1737.995 4839.86 C -1739.755 4842.24 -1741.435 4844.74 -1742.945 4847.49 C -1743.815 4849.07 -1744.535 4850.68 -1745.255 4852.28 C -1748.005 4850.94 -1750.885 4849.75 -1754.025 4848.9 C -1778.685 4842.12 -1810.305 4857.31 -1815.535 4883.82 C -1827.295 4943.38 -1805.415 4995.4 -1759.275 5025.29 C -1767.355 5028.43 -1776.135 5030.68 -1785.755 5031.8 C -1785.755 5031.8 -1858.565 4977.11 -1881.065 4902.11 C -1903.565 4827.11 -1958.565 4482.11 -1886.065 4402.11 C -1813.565 4322.1 -1487.315 4502.11 -1388.565 4602.11 L -1427.315 4695.86",
      "id": "path80"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1793.565 4558.36 C -1765.305 4574.37 -1736.565 4589.41 -1707.745 4604.3 L -1707.615 4604.36 L -1707.275 4604.49 C -1684.365 4612.83 -1661.335 4620.82 -1638.235 4628.61 C -1615.175 4636.51 -1591.995 4644.05 -1568.815 4651.6 C -1545.615 4659.08 -1522.315 4666.27 -1498.945 4673.23 C -1475.635 4680.39 -1452.155 4687.03 -1428.565 4693.36 C -1451.235 4684.27 -1474.005 4675.49 -1496.945 4667.24 C -1519.825 4658.78 -1542.775 4650.55 -1565.825 4642.62 C -1588.895 4634.75 -1611.965 4626.87 -1635.145 4619.35 C -1658.305 4611.73 -1681.525 4604.3 -1704.865 4597.23 L -1704.395 4597.42 C -1733.915 4583.97 -1763.505 4570.67 -1793.565 4558.36",
      "id": "path82"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1782.315 4615.86 C -1775.845 4615.24 -1769.395 4614.44 -1762.965 4613.59 C -1756.535 4612.72 -1750.065 4612.08 -1743.675 4611.01 L -1705.245 4605.04 L -1710.265 4601.62 L -1695.875 4693.63 L -1688.615 4739.6 C -1686.655 4754.98 -1683.985 4770.26 -1683.565 4785.86 C -1681.275 4770.37 -1681.665 4754.54 -1682.565 4738.99 C -1683.515 4723.39 -1684.815 4707.83 -1686.745 4692.35 C -1690.635 4661.41 -1695.555 4630.65 -1701.875 4600.1 L -1702.785 4595.69 L -1706.895 4596.67 L -1744.715 4605.71 C -1751.035 4607.14 -1757.265 4609 -1763.545 4610.62 C -1769.825 4612.27 -1776.095 4613.97 -1782.315 4615.86",
      "id": "path84"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1467.315 4668.36 C -1456.895 4655.91 -1449.225 4642.13 -1442.205 4628.04 C -1435.455 4613.81 -1429.375 4599.26 -1426.065 4583.36 C -1436.515 4595.79 -1444.185 4609.57 -1451.185 4623.68 C -1457.915 4637.91 -1463.995 4652.47 -1467.315 4668.36",
      "id": "path86"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1744.815 4990.86 C -1732.465 4985.29 -1721.695 4976.28 -1712.785 4965.9 C -1703.755 4955.54 -1696.725 4943.54 -1691.155 4930.98 C -1686.145 4918.2 -1682.285 4904.94 -1680.775 4891.37 C -1679.645 4884.65 -1679.855 4877.79 -1679.505 4871.05 C -1679.855 4864.27 -1680.235 4857.53 -1681.065 4850.86 C -1682.505 4857.51 -1683.095 4864.12 -1684.385 4870.64 C -1685.885 4877.12 -1686.715 4883.65 -1688.455 4889.98 C -1691.435 4902.74 -1695.495 4915.1 -1700.355 4927.09 C -1705.445 4939 -1711.625 4950.39 -1718.935 4961.14 C -1726.385 4971.76 -1734.635 4982.06 -1744.815 4990.86",
      "id": "path88"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f57f6a",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1344.985 5368.17 C -1347.375 5431.13 -1355.105 5495.85 -1376.705 5551.56 C -1404.595 5623.29 -1536.105 5651.19 -1627.765 5571.49 C -1670.365 5534.47 -1679.305 5467.34 -1676.755 5406.05 C -1678.975 5407.14 -1680.975 5407.99 -1682.275 5408.31 C -1700.935 5412.96 -1719.675 5398.9 -1725.265 5381.36 C -1729.715 5367.39 -1726.705 5351.6 -1718.725 5339.29 C -1712.095 5329.07 -1701.325 5319.53 -1689.825 5315.15 C -1686.925 5314.05 -1674.015 5311.9 -1664.915 5312.69 C -1656.195 5272.38 -1635.615 5235.14 -1603.855 5208.76 C -1563.845 5175.45 -1512.515 5162.14 -1461.505 5172.74 C -1421.815 5180.95 -1363.075 5206.38 -1348.485 5247.58 C -1344.745 5258.34 -1344.345 5269.9 -1344.265 5281.29 C -1344.265 5283.92 -1344.185 5286.56 -1344.185 5289.18 C -1343.865 5314.69 -1343.945 5341.31 -1344.985 5368.17",
      "id": "path90"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f3664f",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1344.185 5289.18 C -1347.535 5288.31 -1351.035 5287.83 -1354.625 5287.83 C -1377.105 5287.83 -1395.355 5306.08 -1395.355 5328.56 C -1395.355 5351.11 -1377.105 5369.29 -1354.625 5369.29 C -1351.275 5369.29 -1348.085 5368.89 -1344.985 5368.17 C -1343.945 5341.31 -1343.865 5314.69 -1344.185 5289.18",
      "id": "path92"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f3664f",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1598.155 5328.57 C -1598.155 5306.06 -1579.915 5287.82 -1557.405 5287.82 C -1534.905 5287.82 -1516.655 5306.06 -1516.655 5328.57 C -1516.655 5351.07 -1534.905 5369.32 -1557.405 5369.32 C -1579.915 5369.32 -1598.155 5351.07 -1598.155 5328.57",
      "id": "path94"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1416.805 5407.64 C -1416.805 5394.33 -1411.535 5383.54 -1405.035 5383.54 C -1398.535 5383.54 -1393.265 5394.33 -1393.265 5407.64 C -1393.265 5420.95 -1398.535 5431.73 -1405.035 5431.73 C -1411.535 5431.73 -1416.805 5420.95 -1416.805 5407.64",
      "id": "path96"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1381.015 5439.35 C -1383.005 5435.45 -1385.615 5432.05 -1388.975 5429.07 C -1392.305 5426.1 -1396.535 5423.79 -1401.295 5422.7 L -1401.495 5422.66 C -1403.835 5422.11 -1406.175 5423.58 -1406.715 5425.92 C -1407.245 5428.27 -1405.785 5430.6 -1403.445 5431.15 C -1403.065 5431.23 -1402.665 5431.26 -1402.295 5431.25 C -1395.715 5430.99 -1388.405 5434.99 -1383.415 5440.81 L -1383.335 5440.91 C -1382.825 5441.5 -1381.945 5441.57 -1381.355 5441.06 C -1380.845 5440.63 -1380.725 5439.92 -1381.015 5439.35",
      "id": "path98"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1495.195 5407.64 C -1495.195 5394.33 -1500.465 5383.54 -1506.965 5383.54 C -1513.465 5383.54 -1518.725 5394.33 -1518.725 5407.64 C -1518.725 5420.95 -1513.465 5431.73 -1506.965 5431.73 C -1500.465 5431.73 -1495.195 5420.95 -1495.195 5407.64",
      "id": "path100"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1528.585 5440.81 C -1523.595 5435 -1516.285 5430.99 -1509.705 5431.25 C -1507.305 5431.35 -1505.275 5429.48 -1505.175 5427.07 C -1505.085 5424.67 -1506.955 5422.64 -1509.355 5422.55 C -1509.745 5422.53 -1510.125 5422.57 -1510.485 5422.65 L -1510.705 5422.7 C -1515.465 5423.79 -1519.695 5426.1 -1523.025 5429.07 C -1526.385 5432.05 -1528.995 5435.45 -1530.985 5439.35 C -1531.335 5440.04 -1531.065 5440.89 -1530.375 5441.24 C -1529.785 5441.55 -1529.085 5441.39 -1528.665 5440.91 L -1528.585 5440.81",
      "id": "path102"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1411.815 5334.75 C -1415.895 5326.81 -1422.105 5319.95 -1429.555 5314.58 C -1436.995 5309.21 -1446.305 5305.76 -1455.905 5305.83 C -1465.425 5306.07 -1474.795 5309.32 -1482.125 5314.88 C -1485.965 5317.4 -1488.975 5320.92 -1492.285 5323.92 C -1495.055 5327.49 -1497.755 5331.06 -1500.185 5334.75 C -1496.545 5332.09 -1493.235 5329.26 -1489.905 5326.51 C -1486.195 5324.26 -1482.885 5321.49 -1479.135 5319.6 C -1471.825 5315.42 -1463.835 5313.12 -1455.865 5312.99 C -1447.855 5312.8 -1439.875 5315.33 -1432.505 5319.3 C -1425.155 5323.37 -1418.235 5328.63 -1411.815 5334.75",
      "id": "path104"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1443.605 5292.03 C -1446.965 5289.05 -1451.565 5287.97 -1455.995 5287.84 C -1460.445 5287.98 -1464.975 5289.18 -1468.395 5292.03 C -1464.045 5291.34 -1460.085 5290.49 -1455.985 5290.64 C -1451.895 5290.48 -1447.895 5291.19 -1443.605 5292.03",
      "id": "path106"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1485.405 5491.2 C -1490.905 5496.07 -1497.115 5497.66 -1503.645 5497.95 C -1510.115 5498.1 -1516.765 5497.34 -1523.065 5495.19 C -1529.425 5493.26 -1535.275 5489.69 -1540.165 5485.4 C -1545.275 5481.27 -1548.855 5475.81 -1551.835 5470.44 C -1553.355 5467.72 -1552.375 5464.29 -1549.655 5462.78 C -1547.475 5461.57 -1544.845 5461.95 -1543.105 5463.55 L -1542.635 5463.99 C -1538.795 5467.52 -1535.125 5470.82 -1531.005 5473.22 C -1527.055 5475.88 -1522.615 5477.34 -1518.175 5478.49 C -1513.695 5479.53 -1509.035 5480.09 -1504.275 5479.84 C -1499.575 5479.68 -1494.575 5479.44 -1489.415 5480.7 L -1487.925 5481.06 C -1484.755 5481.83 -1482.825 5485.02 -1483.595 5488.19 C -1483.885 5489.4 -1484.545 5490.43 -1485.405 5491.2",
      "id": "path108"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1426.585 5491.2 C -1421.095 5496.07 -1414.885 5497.66 -1408.355 5497.95 C -1401.875 5498.1 -1395.225 5497.34 -1388.925 5495.19 C -1382.575 5493.26 -1376.725 5489.69 -1371.825 5485.4 C -1366.725 5481.27 -1363.145 5475.81 -1360.155 5470.44 C -1358.645 5467.72 -1359.625 5464.29 -1362.345 5462.78 C -1364.525 5461.57 -1367.155 5461.95 -1368.885 5463.55 L -1369.365 5463.99 C -1373.205 5467.52 -1376.875 5470.82 -1380.985 5473.22 C -1384.935 5475.88 -1389.385 5477.34 -1393.825 5478.49 C -1398.295 5479.53 -1402.965 5480.09 -1407.725 5479.84 C -1412.425 5479.68 -1417.425 5479.44 -1422.585 5480.7 L -1424.075 5481.06 C -1427.235 5481.83 -1429.175 5485.02 -1428.405 5488.19 C -1428.105 5489.4 -1427.455 5490.43 -1426.585 5491.2",
      "id": "path110"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1453.265 5444.45 C -1451.185 5435.37 -1449.655 5426.35 -1447.975 5417.42 C -1446.235 5408.52 -1444.595 5399.63 -1442.065 5391.19 C -1441.475 5389.07 -1440.815 5386.99 -1440.065 5384.97 C -1439.455 5383.32 -1437.975 5380.16 -1438.025 5377.2 C -1437.715 5371.18 -1441.565 5365.29 -1446.465 5362.91 C -1451.485 5360.1 -1457.265 5360.54 -1461.825 5362.09 C -1466.465 5363.76 -1470.495 5366.27 -1473.995 5369.36 C -1465.545 5366.19 -1455.675 5363.71 -1449.725 5368.21 C -1446.745 5370.48 -1445.135 5373.5 -1445.555 5376.8 C -1445.715 5378.49 -1446.245 5379.56 -1447.325 5382.14 C -1448.235 5384.4 -1449.025 5386.67 -1449.705 5388.95 C -1452.285 5398.13 -1453.615 5407.4 -1454.125 5416.67 C -1454.665 5425.94 -1454.485 5435.21 -1453.265 5444.45",
      "id": "path112"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1710.505 5368.33 C -1710.635 5373.87 -1709.105 5379.99 -1704.225 5384.28 C -1699.035 5388.52 -1691.655 5388.13 -1686.055 5386.03 C -1680.105 5383.97 -1675.215 5379.89 -1671.375 5375.32 C -1667.445 5370.7 -1664.585 5365.7 -1662.255 5359.94 C -1661.425 5357.88 -1662.415 5355.54 -1664.475 5354.71 C -1666.025 5354.08 -1667.735 5354.49 -1668.845 5355.61 L -1669.105 5355.88 C -1673.025 5359.86 -1677.945 5364.11 -1682.595 5365.42 C -1684.925 5366.03 -1686.655 5365.96 -1688.265 5364.8 C -1689.935 5363.62 -1691.215 5361.12 -1692.315 5358.55 C -1694.365 5353.27 -1695.605 5347.09 -1691.095 5344.64 C -1686.375 5341.95 -1679.445 5342.6 -1673.265 5343.42 C -1679.095 5340.87 -1685.545 5338.71 -1692.855 5340.79 C -1696.575 5342 -1699.525 5346.22 -1699.775 5350.03 C -1700.135 5353.84 -1699.585 5357.3 -1698.635 5360.7 C -1697.625 5364.05 -1696.225 5367.61 -1692.925 5370.54 C -1689.585 5373.54 -1684.335 5374.24 -1680.605 5373.08 C -1672.975 5370.79 -1667.835 5366.39 -1663.045 5361.27 L -1669.895 5357.22 C -1673.585 5366.44 -1679.645 5376.04 -1688.395 5380.37 C -1692.765 5382.45 -1697.945 5383.52 -1702.085 5381.19 C -1706.415 5378.94 -1709.035 5373.63 -1710.505 5368.33",
      "id": "path114"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -1325.615 5484.61 C -1317.315 5659.61 -1550.615 5714.61 -1669.025 5586.31 C -1766.325 5480.8 -1745.325 5251.31 -1734.725 5173.01 C -1732.425 5156.11 -1721.325 5141.61 -1705.325 5135.51 C -1688.025 5128.81 -1670.215 5123.3 -1652.315 5118.91 C -1646.815 5197.51 -1661.725 5291.81 -1665.325 5312.71 C -1674.315 5311.91 -1686.925 5314.01 -1689.815 5315.11 C -1701.325 5319.51 -1712.115 5329.11 -1718.715 5339.31 C -1726.725 5351.61 -1729.725 5367.41 -1725.215 5381.41 C -1719.725 5398.91 -1700.925 5413.01 -1682.315 5408.3 C -1681.015 5408.01 -1679.025 5407.21 -1676.815 5406.11 C -1676.835 5406.59 -1676.845 5407.08 -1676.865 5407.56 C -1570.645 5365.59 -1468.565 5544.61 -1468.565 5544.61 C -1468.565 5544.61 -1386.405 5432.99 -1348.765 5423.42 C -1346.955 5405.03 -1345.725 5386.55 -1345.015 5368.21 C -1343.915 5341.31 -1343.825 5314.71 -1344.225 5289.21 L -1344.225 5281.31 C -1344.315 5269.91 -1344.725 5258.3 -1348.515 5247.61 C -1362.825 5207.31 -1419.225 5182.01 -1458.825 5173.3 C -1460.815 5154.31 -1458.025 5130.01 -1454.225 5108.01 C -1453.915 5106.51 -1453.715 5105.01 -1453.425 5103.61 C -1376.325 5107.91 -1320.615 5121.31 -1320.615 5121.31 C -1320.615 5121.31 -1334.025 5309.61 -1325.615 5484.61",
      "id": "path116"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f7ab76",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -687.575 2805.941 C -687.635 2705.211 -687.315 2642.191 -687.315 2642.191 L -525.445 2625.941 L -500.845 2805.941 L -687.575 2805.941",
      "id": "path118"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -704.365 2673.859 C -704.365 2673.859 -738.985 2640.75 -769.095 2627.191 C -799.195 2613.652 -934.665 2621.18 -925.635 2553.441 L -612.545 2553.441 L -584.705 2581.281 L -584.705 2550.422 L -522.235 2550.422 C -522.235 2550.422 -498.145 2619.672 -520.725 2661.82 C -520.725 2661.82 -565.885 2621.18 -615.555 2639.242 C -665.235 2657.301 -704.365 2673.859 -704.365 2673.859",
      "id": "path120"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f7ab76",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -110.365 2805.941 L -88.155 2635.941 L 69.765 2618.859 C 69.765 2618.859 70.885 2691.582 71.925 2805.941 L -110.365 2805.941",
      "id": "path122"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 91.605 2673.859 C 91.605 2673.859 126.225 2640.75 156.325 2627.191 C 186.435 2613.652 321.905 2621.18 312.875 2553.441 L -0.215 2553.441 L -28.055 2581.281 L -28.055 2550.422 L -90.535 2550.422 C -90.535 2550.422 -114.615 2619.672 -92.035 2661.82 C -92.035 2661.82 -46.875 2621.18 2.795 2639.242 C 52.465 2657.301 91.605 2673.859 91.605 2673.859",
      "id": "path124"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 81.845 2689.281 L -108.155 2689.281 L -301.485 4132.61 L -498.155 2685.941 L -698.155 2685.941 C -698.155 2685.941 -688.155 3819.28 -664.815 4062.61 C -641.485 4305.94 -544.815 4542.61 -544.815 4542.61 L -73.985 4542.61 C -73.985 4542.61 58.515 4302.61 65.185 4032.61 C 71.845 3762.61 71.845 3762.61 71.845 3762.61 L 81.845 2689.281",
      "id": "path126"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -254.815 4527.2 C -253.575 4485.32 -252.625 4443.45 -252.005 4401.57 C -251.525 4359.7 -250.635 4317.83 -250.495 4275.95 L -250.495 4275.29 L -250.705 4274.62 L -296.315 4130.67 L -306.205 4099.47 L -306.055 4132.2 L -305.605 4230.95 C -305.385 4263.86 -305.485 4296.78 -304.895 4329.7 C -304.095 4395.53 -303.125 4461.36 -301.065 4527.2 C -299.015 4461.36 -298.045 4395.53 -297.245 4329.7 C -296.645 4296.78 -296.745 4263.86 -296.535 4230.95 L -296.075 4132.2 L -305.815 4133.72 L -258.935 4277.27 L -259.145 4275.95 C -259.005 4317.83 -258.115 4359.7 -257.635 4401.57 C -257.015 4443.45 -256.065 4485.32 -254.815 4527.2",
      "id": "path128"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -133.565 4523.45 C -131.485 4513.13 -129.455 4502.88 -126.775 4492.78 C -124.385 4482.64 -121.715 4472.57 -118.595 4462.67 C -112.385 4442.9 -105.255 4423.45 -95.715 4405.33 C -86.235 4387.28 -74.405 4370.31 -58.745 4357.55 C -43.275 4344.47 -23.305 4337.42 -2.315 4335.95 C -12.775 4334.67 -23.515 4335.37 -34.065 4337.7 C -44.525 4340.37 -54.395 4345.29 -63.365 4351.4 C -81.485 4363.75 -94.475 4381.91 -104.565 4400.69 C -114.325 4419.79 -121.425 4440.02 -125.995 4460.7 C -130.615 4481.36 -133.585 4502.36 -133.565 4523.45",
      "id": "path130"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -484.815 4518.45 C -484.565 4497.86 -486.615 4477.23 -490.645 4456.94 C -494.685 4436.65 -500.555 4416.59 -509.335 4397.55 C -518.135 4378.67 -529.975 4360.41 -546.805 4347.1 C -555.095 4340.42 -564.765 4335.31 -575.025 4332.61 C -585.295 4330.05 -595.885 4329.4 -606.065 4330.94 C -585.465 4331.85 -566.135 4339.49 -551.825 4353.07 C -537.385 4366.43 -526.685 4383.59 -518.405 4401.76 C -509.835 4419.87 -503.705 4439.2 -498.215 4458.71 C -493.005 4478.31 -488.415 4498.21 -484.815 4518.45",
      "id": "path132"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -682.315 2730.941 C -653.155 2734.879 -623.985 2735.781 -594.815 2735.941 C -565.655 2735.801 -536.485 2734.91 -507.315 2730.941 C -536.485 2726.992 -565.655 2726.09 -594.815 2725.949 C -623.985 2726.109 -653.155 2727.019 -682.315 2730.941",
      "id": "path134"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -104.815 2730.941 C -75.655 2734.879 -46.485 2735.781 -17.315 2735.941 C 11.845 2735.801 41.015 2734.91 70.185 2730.941 C 41.015 2726.992 11.845 2726.09 -17.315 2725.949 C -46.485 2726.109 -75.655 2727.019 -104.815 2730.941",
      "id": "path136"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f7ab76",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -396.105 5423.01 L -396.905 5429.61 C -396.565 5427.07 -396.265 5424.74 -396.105 5423.01 Z M 13.795 5222.4 C -9.275 5249.09 -43.555 5263.2 -80.195 5264.6 C -103.375 5265.49 -123.305 5269.43 -140.575 5275.38 C -155.445 5295.92 -205.825 5323.61 -216.375 5365.97 C -219.435 5385.66 -221.375 5406.25 -219.695 5422.93 L -219.695 5423.01 C -218.825 5432.41 -216.825 5440.54 -213.245 5446.52 L -306.405 5494.14 L -404.525 5462.75 C -402.095 5458.7 -399.515 5446.22 -397.815 5435.65 C -396.545 5418.97 -396.915 5390.76 -399.145 5369.6 L -399.285 5369.6 C -407.715 5325.16 -460.125 5296.51 -475.415 5275.38 C -492.675 5269.43 -512.615 5265.49 -535.795 5264.6 C -572.435 5263.2 -606.715 5249.09 -629.785 5222.4 C -661.165 5186.1 -681.675 5120.89 -644.405 5008.28 C -579.885 4813.29 -530.625 4664.3 -531.555 4576.2 L -84.435 4576.2 C -85.355 4664.3 -36.105 4813.29 28.415 5008.28 C 65.685 5120.89 45.175 5186.1 13.795 5222.4",
      "id": "path138"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -544.995 4594.46 C -547.695 4583.57 -547.865 4567.65 -547.485 4555.56 C -547.175 4545.84 -539.475 4538.02 -529.755 4537.47 C -446.605 4532.72 -81.375 4513.34 -73.985 4538.45 C -65.655 4566.78 -72.315 4595.11 -72.315 4595.11 C -72.315 4595.11 -53.155 4719.28 -21.485 4818.45 C 10.185 4917.61 66.845 5084.28 51.015 5155.95 C 35.185 5227.61 -23.985 5264.28 -63.155 5268.45 C -102.315 5272.61 -153.985 5293.45 -153.985 5293.45 C -153.985 5293.45 -263.985 5232.61 -303.155 5227.61 C -342.315 5222.61 -459.815 5293.45 -459.815 5293.45 C -459.815 5293.45 -498.155 5276.78 -530.655 5270.95 C -563.155 5265.11 -662.315 5250.11 -672.315 5132.61 C -681.145 5028.86 -571.735 4696.42 -546.005 4620.03 C -543.215 4611.75 -542.895 4602.94 -544.995 4594.46",
      "id": "path140"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f1485b",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -261.015 5233.45 L -307.895 5232.99 L -354.765 5233.45 L -368.515 5170.32 L -329.145 5110.95 L -325.395 5110.95 L -290.395 5110.95 L -286.645 5110.95 L -247.265 5170.32 L -261.015 5233.45",
      "id": "path142"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#e9f8fd",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -184.455 5332.82 L -299.455 5249.07 L -307.585 5249.65 L -307.585 5249.7 L -307.895 5249.67 L -308.205 5249.7 L -308.205 5249.65 L -316.335 5249.07 L -431.335 5332.82 L -508.205 5280.32 L -403.205 5194.7 L -323.205 5224.07 L -308.205 5197.07 L -308.205 5195.95 L -307.895 5196.51 L -307.585 5195.95 L -307.585 5197.07 L -292.585 5224.07 L -212.585 5194.7 L -107.585 5280.32 L -184.455 5332.82",
      "id": "path144"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f1485b",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -324.815 5135.95 L -377.315 4670.95 L -306.065 4607.2 L -234.815 4673.45 L -286.645 5110.95 L -324.815 5135.95",
      "id": "path146"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -503.985 5277.61 L -405.655 5195.95 L -358.985 5210.11 L -401.485 5176.78 L -503.985 5277.61",
      "id": "path148"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -257.315 5210.95 L -213.985 5195.11 L -110.655 5277.61 L -210.655 5171.78 L -257.315 5210.95",
      "id": "path150"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 20.685 4668.85 C 19.875 4669.05 19.085 4669.14 18.285 4669.25 C -149.815 4695.84 -331.115 4745.55 -491.015 4837.35 L -472.515 4890.65 L -464.015 4913.9 C -464.015 4913.9 -462.915 4913.8 -460.915 4913.6 C -440.215 4911.8 -319.925 4897.75 -165.815 4885.15 C -128.315 4882.04 -88.915 4878.85 -48.515 4875.65 C -54.315 4893.15 -59.925 4910.05 -65.415 4926.35 C -67.515 4932.35 -69.515 4938.34 -71.515 4944.14 C -74.415 4952.65 -77.225 4960.95 -80.015 4968.85 C -93.815 5008.94 -106.215 5043.25 -116.215 5069.05 C -129.925 5104.34 -137.425 5133.34 -140.725 5157.35 C -151.915 5237.55 -68.915 5287.04 -3.115 5237.85 C 22.575 5218.54 49.085 5186.55 71.285 5133.94 C 97.085 5073.15 137.775 4976.75 176.385 4858.54 C 176.885 4856.95 177.485 4855.25 177.985 4853.54 C 210.685 4752.75 125.275 4652.35 20.685 4668.85",
      "id": "path152"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -118.985 5094.28 C -111.425 5076.75 -104.565 5058.99 -98.045 5041.12 C -91.305 5023.31 -85.085 5005.33 -79.125 4987.26 C -73.075 4969.23 -67.355 4951.09 -61.895 4932.87 C -56.335 4914.67 -51.455 4896.25 -46.455 4877.88 L -49.245 4879.31 C -39.855 4881.54 -30.545 4883.99 -21.065 4885.95 C -29.925 4882.06 -38.945 4878.69 -47.895 4875.08 L -49.845 4874.29 L -50.685 4876.51 C -57.415 4894.32 -64.285 4912.08 -70.455 4930.07 C -76.735 4948.02 -82.735 4966.06 -88.425 4984.21 C -94.205 5002.33 -99.725 5020.53 -104.725 5038.9 C -109.935 5057.21 -114.815 5075.62 -118.985 5094.28",
      "id": "path154"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -315.655 4755.95 L -151.485 4823.45 L -280.655 4741.78 L -315.655 4755.95 Z",
      "id": "path156"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -39.815 4859.7 C -44.805 4860.85 -47.055 4863.37 -48.665 4866.21 C -49.985 4869.19 -50.655 4872.5 -48.565 4877.2 C -43.565 4876.05 -41.315 4873.53 -39.725 4870.68 C -38.415 4867.69 -37.745 4864.37 -39.815 4859.7",
      "id": "path158"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -240.655 4728.45 C -209.215 4724.78 -178.385 4718.14 -147.755 4710.79 C -117.195 4703.14 -86.815 4694.75 -57.315 4683.45 C -88.935 4687.13 -119.665 4693.75 -150.215 4701.1 C -180.705 4708.75 -210.975 4717.11 -240.655 4728.45",
      "id": "path160"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f7ab76",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -464.175 4913.42 L -472.515 4890.65 L -558.225 4883.05 C -592.515 4880.05 -627.115 4887.85 -656.115 4906.44 C -662.425 4910.45 -666.615 4913.94 -666.915 4915.95 C -669.015 4926.75 -584.925 4912.35 -584.925 4912.35 C -584.925 4912.35 -658.115 4939.54 -655.015 4945.15 C -647.225 4959.05 -543.415 4923.65 -540.815 4934.95 C -538.615 4944.95 -558.815 4962.85 -570.815 4970.25 C -573.315 4971.75 -573.915 4974.95 -572.015 4977.24 C -568.225 4981.75 -560.615 4986.95 -547.515 4980.05 C -529.515 4970.45 -464.175 4913.42 -464.175 4913.42",
      "id": "path162"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -150.855 4823.34 C -113.995 4840.36 -79.425 4857.93 -48.545 4875.64 L -174.475 4908.91 L -176.065 4914.7 L -565.675 4882.94 C -539.975 4960.41 -517.135 5026.24 -500.445 5069.05 C -486.735 5104.28 -479.245 5133.37 -475.895 5157.28 C -464.735 5237.54 -547.785 5287.03 -613.535 5237.86 C -639.285 5218.57 -665.745 5186.53 -687.985 5133.92 C -713.725 5073.11 -754.455 4976.67 -793.035 4858.55 C -793.565 4856.91 -794.105 4855.25 -794.645 4853.6 C -827.295 4752.78 -741.945 4652.36 -637.265 4668.9 C -636.505 4669.02 -635.745 4669.14 -634.975 4669.26 C -499.815 4690.59 -306.455 4751.7 -152.695 4822.5 L -150.655 4822.61 L -150.855 4823.34",
      "id": "path164"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f7ab76",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -65.445 4926.33 C -73.255 4925.37 -78.355 4925.69 -78.915 4928.08 C -79.945 4932.46 -76.605 4938.36 -71.505 4944.18 C -74.375 4952.63 -77.235 4960.92 -80.035 4968.89 C -97.915 4959.01 -125.535 4941.44 -150.685 4911.73 L -175.235 4909.28 L -150.655 4822.61 L -48.545 4875.64 C -54.365 4893.17 -59.945 4910.07 -65.445 4926.33",
      "id": "path166"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -174.815 4914.28 C -207.235 4909.78 -239.725 4906.13 -272.235 4902.76 C -304.725 4899.15 -337.275 4896.32 -369.835 4893.54 C -402.395 4890.78 -434.975 4888.32 -467.595 4886.18 C -500.215 4884.26 -532.835 4882.17 -565.525 4880.99 L -564.085 4882.17 C -567.585 4871.46 -571.085 4860.76 -574.815 4850.11 C -572.435 4861.14 -569.825 4872.09 -567.225 4883.06 L -566.975 4884.09 L -565.785 4884.23 C -533.335 4888.33 -500.805 4891.52 -468.295 4894.88 C -435.765 4898.01 -403.215 4900.84 -370.635 4903.35 C -338.055 4905.85 -305.465 4908.3 -272.825 4909.96 C -240.185 4911.87 -207.535 4913.5 -174.815 4914.28",
      "id": "path168"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -607.315 4869.7 C -601.545 4875.61 -594.865 4878.61 -587.965 4880.93 C -580.975 4882.94 -573.765 4884.25 -565.655 4882.61 C -571.425 4876.67 -578.105 4873.68 -585.005 4871.38 C -592.005 4869.39 -599.205 4868.08 -607.315 4869.7",
      "id": "path170"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -568.155 4682.61 C -568.155 4682.61 -448.155 4704.28 -368.155 4739.28 L -553.155 4644.28 L -568.155 4682.61",
      "id": "path172"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -535.655 4977.61 C -530.895 5003.21 -523.275 5027.82 -514.955 5052.17 C -506.355 5076.43 -497.025 5100.44 -484.815 5123.45 C -489.555 5097.84 -497.175 5073.24 -505.515 5048.89 C -514.135 5024.63 -523.465 5000.62 -535.655 4977.61",
      "id": "path174"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f7ab76",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -97.565 5630.96 C -103.135 5648.46 -121.805 5662.49 -140.425 5657.93 C -132.165 5901.25 -335.005 5868.48 -335.005 5868.48 C -462.325 5857.43 -476.845 5722.1 -475.905 5653.19 C -480.015 5655.58 -483.885 5657.38 -486.035 5657.91 C -504.695 5662.57 -523.435 5648.5 -529.025 5630.96 C -533.475 5616.99 -530.465 5601.2 -522.485 5588.9 C -515.855 5578.67 -505.085 5569.13 -493.585 5564.75 C -490.965 5563.75 -480.145 5561.91 -471.365 5562.15 C -451.665 5403.12 -307.585 5418.77 -307.585 5418.77 C -182.655 5412.59 -150.215 5499.84 -142.935 5562.84 C -138.295 5563.41 -134.435 5564.21 -133.005 5564.75 C -121.495 5569.13 -110.735 5578.67 -104.095 5588.9 C -96.125 5601.2 -93.105 5616.99 -97.565 5630.96",
      "id": "path176"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -241.395 5532.82 C -241.395 5532.82 -252.225 5596.99 -310.565 5596.99 C -368.895 5596.99 -384.725 5537.82 -384.725 5537.82 C -411.535 5545.55 -432.275 5594.95 -444.195 5631.51 C -451.785 5654.78 -444.105 5680.59 -424.305 5694.98 C -424.145 5695.1 -423.985 5695.21 -423.835 5695.32 C -408.205 5706.57 -421.335 5710.32 -410.705 5742.2 C -410.115 5743.97 -409.415 5745.67 -408.635 5747.32 C -396.015 5773.62 -360.395 5776.65 -339.535 5756.27 C -337.375 5754.16 -334.825 5752.24 -332.055 5750.44 C -325.315 5745.22 -317.205 5741.98 -307.665 5742.21 C -307.635 5742.21 -307.615 5742.2 -307.585 5742.2 C -307.155 5742.16 -306.775 5742.23 -306.345 5742.2 C -305.925 5742.23 -305.545 5742.16 -305.115 5742.2 C -305.085 5742.2 -305.065 5742.21 -305.035 5742.21 C -295.495 5741.98 -287.385 5745.22 -280.635 5750.44 C -277.865 5752.24 -275.315 5754.16 -273.165 5756.27 C -252.295 5776.65 -216.675 5773.62 -204.065 5747.32 C -203.275 5745.67 -202.585 5743.97 -201.995 5742.2 C -191.365 5710.32 -204.495 5706.57 -188.865 5695.32 C -187.115 5694.06 -185.355 5692.72 -183.625 5691.34 C -164.885 5676.38 -157.455 5650.68 -166.085 5628.31 C -188.725 5569.58 -241.395 5532.82 -241.395 5532.82 L -241.395 5532.82 Z M -114.495 5714.7 C -113.245 5742.2 -147.615 5845.95 -234.495 5868.45 C -262.425 5875.68 -286.475 5877.78 -306.345 5877.34 C -326.215 5877.78 -350.275 5875.68 -378.205 5868.45 C -465.085 5845.95 -499.455 5742.2 -498.205 5714.7 C -497.815 5705.95 -495.135 5696.97 -491.685 5688.77 C -482.555 5667.1 -476.905 5644.12 -476.585 5620.61 C -476.305 5600.64 -475.565 5578.67 -473.895 5560.95 C -469.725 5516.78 -420.565 5390.11 -318.065 5390.11 C -215.565 5390.11 -168.065 5465.95 -148.065 5520.95 C -138.265 5547.89 -135.865 5583.62 -135.975 5613.06 C -136.065 5639.07 -131.095 5664.81 -120.995 5688.79 C -117.545 5696.98 -114.885 5705.96 -114.495 5714.7",
      "id": "path178"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -268.385 5649.27 C -268.385 5635.97 -263.115 5625.18 -256.615 5625.18 C -250.115 5625.18 -244.845 5635.97 -244.845 5649.27 C -244.845 5662.58 -250.115 5673.36 -256.615 5673.36 C -263.115 5673.36 -268.385 5662.58 -268.385 5649.27",
      "id": "path180"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -346.775 5649.27 C -346.775 5635.97 -352.045 5625.18 -358.545 5625.18 C -365.045 5625.18 -370.315 5635.97 -370.315 5649.27 C -370.315 5662.58 -365.045 5673.36 -358.545 5673.36 C -352.045 5673.36 -346.775 5662.58 -346.775 5649.27",
      "id": "path182"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -336.995 5732.84 C -342.485 5737.71 -348.695 5739.3 -355.225 5739.59 C -361.695 5739.74 -368.345 5738.97 -374.645 5736.83 C -380.995 5734.89 -386.855 5731.32 -391.745 5727.03 C -396.855 5722.9 -400.435 5717.45 -403.425 5712.07 C -404.935 5709.35 -403.955 5705.92 -401.235 5704.41 C -399.055 5703.2 -396.425 5703.59 -394.685 5705.18 L -394.215 5705.62 C -390.375 5709.15 -386.705 5712.45 -382.595 5714.85 C -378.635 5717.51 -374.195 5718.97 -369.755 5720.12 C -365.285 5721.16 -360.615 5721.72 -355.855 5721.47 C -351.165 5721.31 -346.155 5721.07 -340.995 5722.33 L -339.505 5722.69 C -336.345 5723.47 -334.405 5726.66 -335.175 5729.82 C -335.475 5731.03 -336.125 5732.06 -336.995 5732.84",
      "id": "path184"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -278.165 5732.84 C -272.675 5737.71 -266.465 5739.3 -259.935 5739.59 C -253.465 5739.74 -246.805 5738.97 -240.515 5736.83 C -234.155 5734.89 -228.305 5731.32 -223.415 5727.03 C -218.305 5722.9 -214.725 5717.45 -211.745 5712.07 C -210.225 5709.35 -211.205 5705.92 -213.925 5704.41 C -216.105 5703.2 -218.735 5703.59 -220.475 5705.18 L -220.955 5705.62 C -224.775 5709.15 -228.465 5712.45 -232.575 5714.85 C -236.525 5717.51 -240.965 5718.97 -245.405 5720.12 C -249.875 5721.16 -254.545 5721.72 -259.305 5721.47 C -264.005 5721.31 -269.005 5721.07 -274.165 5722.33 L -275.655 5722.69 C -278.815 5723.47 -280.755 5726.66 -279.985 5729.82 C -279.685 5731.03 -279.035 5732.06 -278.165 5732.84",
      "id": "path186"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -304.855 5686.08 C -302.775 5677.01 -301.235 5667.99 -299.555 5659.06 C -297.815 5650.16 -296.175 5641.26 -293.645 5632.83 C -293.055 5630.7 -292.405 5628.62 -291.645 5626.61 C -291.035 5624.96 -289.555 5621.79 -289.605 5618.83 C -289.295 5612.82 -293.145 5606.92 -298.055 5604.54 C -303.065 5601.73 -308.855 5602.17 -313.415 5603.72 C -318.045 5605.39 -322.075 5607.9 -325.575 5611 C -317.125 5607.83 -307.255 5605.35 -301.315 5609.84 C -298.325 5612.11 -296.715 5615.14 -297.135 5618.43 C -297.285 5620.12 -297.825 5621.2 -298.905 5623.78 C -299.815 5626.03 -300.605 5628.3 -301.285 5630.58 C -303.865 5639.76 -305.195 5649.03 -305.705 5658.3 C -306.245 5667.57 -306.065 5676.85 -304.855 5686.08",
      "id": "path188"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -514.265 5617.94 C -514.395 5623.47 -512.865 5629.59 -507.985 5633.88 C -502.795 5638.13 -495.415 5637.74 -489.815 5635.63 C -483.865 5633.57 -478.975 5629.5 -475.135 5624.93 C -471.205 5620.31 -468.345 5615.3 -466.015 5609.54 C -465.185 5607.48 -466.175 5605.14 -468.235 5604.31 C -469.785 5603.69 -471.495 5604.1 -472.605 5605.21 L -472.865 5605.49 C -476.785 5609.47 -481.705 5613.71 -486.355 5615.03 C -488.685 5615.63 -490.415 5615.56 -492.025 5614.4 C -493.695 5613.23 -494.975 5610.73 -496.075 5608.15 C -498.125 5602.87 -499.365 5596.69 -494.855 5594.24 C -490.135 5591.56 -483.205 5592.21 -477.025 5593.03 C -482.855 5590.47 -489.305 5588.31 -496.615 5590.39 C -500.335 5591.6 -503.285 5595.82 -503.535 5599.63 C -503.885 5603.45 -503.345 5606.91 -502.395 5610.3 C -501.385 5613.65 -499.985 5617.21 -496.685 5620.15 C -493.345 5623.14 -488.095 5623.85 -484.365 5622.69 C -476.735 5620.39 -471.595 5615.99 -466.805 5610.87 L -473.655 5606.82 C -477.345 5616.04 -483.405 5625.64 -492.155 5629.97 C -496.525 5632.06 -501.705 5633.12 -505.845 5630.79 C -510.175 5628.55 -512.795 5623.23 -514.265 5617.94",
      "id": "path190"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -107.065 5617.94 C -106.935 5623.47 -108.465 5629.59 -113.345 5633.88 C -118.535 5638.13 -125.915 5637.74 -131.525 5635.63 C -137.475 5633.57 -142.355 5629.5 -146.195 5624.93 C -150.135 5620.31 -152.995 5615.3 -155.325 5609.54 C -156.155 5607.48 -155.155 5605.14 -153.105 5604.31 C -151.555 5603.69 -149.845 5604.1 -148.735 5605.21 L -148.475 5605.49 C -144.555 5609.47 -139.635 5613.71 -134.975 5615.03 C -132.645 5615.63 -130.925 5615.56 -129.305 5614.4 C -127.645 5613.23 -126.365 5610.73 -125.265 5608.15 C -123.215 5602.87 -121.975 5596.69 -126.485 5594.24 C -131.205 5591.56 -138.135 5592.21 -144.305 5593.03 C -138.475 5590.47 -132.035 5588.31 -124.715 5590.39 C -121.005 5591.6 -118.045 5595.82 -117.805 5599.63 C -117.445 5603.45 -117.995 5606.91 -118.945 5610.3 C -119.945 5613.65 -121.355 5617.21 -124.645 5620.15 C -127.985 5623.14 -133.235 5623.85 -136.975 5622.69 C -144.595 5620.39 -149.745 5615.99 -154.535 5610.87 L -147.675 5606.82 C -143.995 5616.04 -137.935 5625.64 -129.185 5629.97 C -124.805 5632.06 -119.625 5633.12 -115.485 5630.79 C -111.155 5628.55 -108.535 5623.23 -107.065 5617.94",
      "id": "path192"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M -348.155 5573.45 C -348.155 5573.45 -312.315 5553.45 -271.485 5573.45 C -271.485 5573.45 -304.405 5494.28 -348.155 5573.45",
      "id": "path194"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#c76043",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 700.235 3483.95 C 673.235 3079.9 656.215 2652.301 656.215 2652.301 L 740.365 2601.449 L 812.415 2663.949 L 1009.775 3483.95 L 700.235 3483.95",
      "id": "path196"
    }
  }), _c('path', {
    staticStyle: {
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none",
      "fill": "rgb(16, 14, 14)"
    },
    attrs: {
      "d": "M 816.285 2672.801 C 818.255 2674.711 821.475 2673.699 822.095 2671.019 C 824.825 2659.371 831.065 2633.199 838.005 2608.129 C 845.325 2581.691 824.985 2561.109 816.015 2553.551 C 813.525 2551.461 810.475 2550.422 807.225 2550.422 L 430.545 2550.711 C 430.545 2550.711 413.635 2576.621 535.275 2605.851 C 656.925 2635.082 610.695 2670.48 648.355 2665.422 C 686.035 2660.371 733.315 2609.062 769.875 2635.172 C 795.065 2653.172 809.645 2666.34 816.285 2672.801",
      "id": "path198"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 693.695 3382.28 C 693.695 3382.28 822.025 3325.62 967.865 3310.62 C 967.865 3310.62 864.525 3271.45 689.525 3330.62 L 693.695 3382.28",
      "id": "path200"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#c76043",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1125.745 3483.95 L 1152.355 2663.949 L 1217.865 2601.449 L 1306.505 2652.301 C 1306.505 2652.301 1364.525 3079.9 1408.465 3483.95 L 1125.745 3483.95",
      "id": "path202"
    }
  }), _c('path', {
    staticStyle: {
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none",
      "fill": "rgb(16, 14, 14)"
    },
    attrs: {
      "d": "M 1153.855 2672.801 C 1151.885 2674.711 1148.675 2673.699 1148.045 2671.019 C 1145.325 2659.371 1139.075 2633.199 1132.135 2608.129 C 1124.815 2581.691 1145.165 2561.109 1154.135 2553.551 C 1156.615 2551.461 1159.675 2550.422 1162.915 2550.422 L 1539.595 2550.711 C 1539.595 2550.711 1556.515 2576.621 1434.865 2605.851 C 1313.215 2635.082 1359.455 2670.48 1321.785 2665.422 C 1284.115 2660.371 1236.835 2609.062 1200.275 2635.172 C 1175.085 2653.172 1160.495 2666.34 1153.855 2672.801",
      "id": "path204"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1131.195 3303.12 C 1131.195 3303.12 1279.525 3309.78 1396.195 3377.28 L 1387.865 3303.12 C 1387.865 3303.12 1237.865 3273.12 1131.195 3303.12",
      "id": "path206"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f9a729",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 894.525 4518.95 C 894.525 4518.95 769.525 4268.95 739.525 4043.95 C 709.525 3818.95 692.025 3383.95 692.025 3383.95 C 692.025 3383.95 1099.525 3201.45 1409.525 3383.95 C 1409.525 3383.95 1544.525 4268.95 1394.525 4516.45 L 894.525 4518.95",
      "id": "path208"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1032.675 3752.7 C 1053.255 3767.6 1072.865 3782.52 1090.925 3799.46 C 1109.155 3816.19 1125.515 3834.61 1141.955 3854 C 1132.245 3830.4 1116.375 3809.58 1097.715 3792.12 C 1078.875 3774.86 1056.925 3760.61 1032.675 3752.7",
      "id": "path210"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1080.415 3727.55 C 1097.685 3743.17 1114.445 3758.18 1129.925 3774.67 C 1145.625 3790.96 1159.785 3808.44 1174.545 3826.44 C 1166.655 3804.45 1153.165 3784.77 1137.165 3767.78 C 1120.965 3750.98 1101.975 3736.54 1080.415 3727.55",
      "id": "path212"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 922.025 4463.95 C 905.285 4421.46 889.115 4378.77 873.985 4335.72 C 858.595 4292.77 844.025 4249.53 830.655 4205.94 C 804.205 4118.71 780.575 4030.46 775.765 3939.22 L 750.255 3666.48 L 736.665 3530.17 L 722.025 3393.95 L 731.785 3530.6 L 742.585 3667.17 L 765.825 3940.18 C 767.905 3962.9 769.815 3985.63 773.215 4008.48 C 776.655 4031.2 780.925 4053.78 786.225 4076.07 C 796.635 4120.71 808.885 4164.86 823.345 4208.26 C 851.925 4295.15 884.805 4380.53 922.025 4463.95",
      "id": "path214"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#c76043",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1456.465 4464.4 C 1434.475 4432.68 1420.635 4412.78 1418.415 4409.59 C 1418.325 4409.47 1418.345 4409.48 1418.295 4409.4 C 1374.315 4401.53 1342.815 4382.45 1327.045 4372.46 C 1314.875 4364.76 1315.575 4355.8 1317.565 4350.44 C 1318.585 4347.72 1321.535 4346.71 1324.055 4348.08 C 1336.065 4354.62 1361.065 4363.1 1368.435 4356.34 C 1376.755 4348.7 1296.555 4277.95 1304.555 4264.65 C 1307.775 4259.31 1366.195 4308.11 1366.195 4308.11 C 1366.195 4308.11 1313.285 4243.86 1323.485 4240.38 C 1333.665 4236.91 1387.465 4287.37 1387.465 4287.37 C 1387.465 4287.37 1342.245 4216.86 1353.995 4217.73 C 1365.735 4218.59 1408.325 4268.02 1408.325 4268.02 C 1394.595 4240.52 1392.825 4227.32 1393.605 4221.18 C 1393.965 4218.26 1397.025 4217.11 1399.135 4219.12 C 1424.905 4243.68 1455.405 4319.86 1467.595 4352.25 L 1467.605 4352.24 L 1467.835 4351.93 C 1493.855 4367.2 1519.125 4383.6 1543.715 4400.85 C 1514.565 4421.98 1485.055 4442.55 1456.465 4464.4",
      "id": "path216"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1322.025 5158.95 C 1322.025 5158.95 1387.025 5168.95 1487.025 5108.95 C 1587.025 5048.95 1839.525 4816.45 1834.525 4728.95 C 1829.525 4641.45 1502.025 4356.45 1502.025 4356.45 L 1429.525 4446.45 L 1607.025 4708.95 L 1362.855 4937.08 L 1322.025 5158.95",
      "id": "path218"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#c76043",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1239.555 5202.51 C 1235.825 5224.04 1233.185 5247.66 1235.045 5266.23 L 1235.045 5266.31 C 1235.905 5275.48 1237.845 5283.41 1241.345 5289.23 L 1150.505 5335.67 L 1054.845 5305.06 C 1058.335 5299.23 1062.195 5275.48 1063.045 5266.31 L 1061.125 5282.06 C 1062.995 5263.49 1062.275 5224.04 1058.545 5202.51 C 1053.025 5171.04 1045.095 5144.15 1045.095 5144.15 L 1121.855 5144.15 L 1139.335 5144.15 L 1252.995 5144.15 C 1252.995 5144.15 1245.075 5171.04 1239.555 5202.51",
      "id": "path220"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#c1473b",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1061.125 5282.06 C 1061.125 5282.06 1122.975 5238.52 1237.125 5278.67 C 1237.125 5278.67 1147.885 5148.81 1061.125 5282.06",
      "id": "path222"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 896.195 4558.95 C 890.165 4536.83 886.195 4502.28 886.195 4502.28 C 1192.025 4436.45 1400.365 4502.28 1400.365 4502.28 C 1400.365 4502.28 1407.025 4508.12 1400.365 4544.78 C 1393.695 4581.45 1442.025 4777.28 1454.525 4828.95 C 1467.025 4880.62 1468.695 5027.28 1459.525 5078.95 C 1450.365 5130.62 1364.525 5161.45 1334.525 5158.12 C 1304.525 5154.78 1248.695 5181.45 1248.695 5181.45 C 1155.365 5098.95 1051.195 5181.45 1051.195 5181.45 C 1051.195 5181.45 1010.365 5157.28 937.025 5153.95 C 937.025 5153.95 819.525 5082.28 811.195 5002.28 C 802.865 4922.28 918.695 4641.45 896.195 4558.95",
      "id": "path224"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1008.645 4734.53 C 1019.265 4729.39 1030.655 4726.84 1042.145 4726.62 C 1053.615 4726.14 1065.125 4727.24 1076.635 4728.88 C 1099.505 4732.26 1123.505 4735.95 1147.575 4733.36 C 1171.485 4730.86 1194.155 4724.61 1216.925 4721.02 C 1228.305 4719.23 1239.835 4718.34 1251.305 4719.03 C 1262.805 4719.39 1274.235 4721.79 1285.145 4726.22 C 1275.255 4719.74 1263.575 4716.19 1251.815 4714.15 C 1239.955 4712.43 1227.915 4712.47 1216.035 4713.38 C 1192.225 4715.3 1169.395 4721.29 1146.595 4723.42 C 1123.855 4726.12 1101.005 4722.9 1077.385 4721.26 C 1065.615 4720.54 1053.605 4720.23 1041.705 4721.78 C 1029.875 4723.63 1018.125 4727.43 1008.645 4734.53",
      "id": "path226"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1046.195 5176.45 C 1034.755 5156.81 1024.375 5136.29 1018.525 5114.6 C 1015.695 5103.87 1013.815 5092.55 1016.075 5082.24 C 1018.115 5071.97 1026.115 5063.89 1036.115 5062.23 C 1046.135 5060.43 1057.035 5063.28 1067.245 5067.05 C 1077.515 5070.98 1087.405 5076.27 1096.965 5082.09 C 1106.525 5087.93 1115.775 5094.37 1124.805 5101.12 L 1138.195 5111.5 L 1144.935 5116.87 L 1145.935 5117.61 L 1146.715 5118.13 L 1146.985 5118.3 C 1147.385 5118.52 1148.195 5118.83 1148.845 5118.91 C 1147.935 5123.74 1157.595 5110.14 1154.265 5112.43 L 1154.395 5112.63 C 1154.745 5113.19 1154.785 5114 1154.545 5114.53 C 1154.375 5114.91 1154.765 5114.17 1154.835 5114.05 C 1155.395 5112.99 1156.015 5111.9 1156.785 5110.73 C 1168.485 5092.16 1183.455 5074.73 1200.725 5061.17 C 1209.395 5054.42 1218.905 5048.63 1229.135 5045.79 C 1234.225 5044.44 1239.455 5043.44 1244.625 5043.85 C 1249.985 5043.54 1254.465 5044.92 1258.115 5047.93 C 1265.415 5054.12 1267.745 5065.78 1268.335 5076.58 C 1268.965 5087.63 1267.835 5098.9 1266.305 5110.06 C 1263.245 5132.47 1257.635 5154.59 1251.195 5176.45 C 1259.785 5155.31 1266.385 5133.36 1271.135 5110.87 C 1273.225 5099.57 1274.815 5088.09 1274.645 5076.35 C 1274.275 5064.94 1273.125 5051.77 1263.165 5042.13 C 1258.255 5037.51 1251.035 5035.34 1245.045 5035.48 C 1238.835 5034.87 1232.675 5035.99 1226.815 5037.47 C 1214.975 5040.61 1204.575 5046.85 1195.225 5053.92 C 1176.525 5068.3 1161.065 5085.76 1148.255 5105.53 C 1147.475 5106.74 1146.705 5108.14 1145.955 5109.6 C 1145.705 5110.12 1145.695 5109.97 1145.275 5111.03 C 1144.825 5112.23 1144.645 5113.71 1144.775 5114.95 L 1144.825 5115.41 C 1141.455 5117.77 1151.105 5104.33 1150.095 5109.09 C 1150.655 5109.12 1151.385 5109.4 1151.695 5109.59 L 1151.755 5109.62 C 1151.895 5109.71 1151.725 5109.59 1151.645 5109.54 L 1150.925 5109.01 L 1144.235 5103.83 C 1139.705 5100.31 1135.125 5096.84 1130.465 5093.45 C 1121.165 5086.68 1111.605 5080.21 1101.645 5074.31 C 1091.675 5068.43 1081.325 5063.03 1070.255 5058.96 C 1059.265 5055 1047.075 5052 1034.515 5054.74 C 1021.795 5057.23 1011.675 5068.69 1009.905 5080.98 C 1007.835 5093.19 1010.415 5104.98 1013.855 5115.99 C 1021.505 5137.87 1032.845 5157.97 1046.195 5176.45",
      "id": "path228"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 912.865 4496.45 C 914.795 4508.65 917.425 4520.71 920.505 4532.74 C 922.165 4538.72 924.055 4544.65 926.285 4550.53 C 927.405 4553.46 928.595 4556.39 929.955 4559.28 C 931.265 4562.17 932.025 4564.71 933.105 4567.4 C 939.025 4590.09 938.255 4614.94 936.375 4638.96 C 934.475 4663.15 930.145 4687.18 924.215 4710.77 C 921.185 4722.54 917.765 4734.28 913.185 4745.57 C 909.265 4757.18 903.615 4768 897.865 4778.95 C 913.385 4759.62 923.805 4736.49 931.595 4712.92 C 939.445 4689.26 944.155 4664.65 946.335 4639.8 C 947.955 4615 948.705 4589.56 940.335 4564.9 C 938.965 4561.95 937.585 4558.7 936.155 4556.08 C 934.695 4553.51 933.365 4550.81 932.075 4548.09 C 929.505 4542.63 927.295 4536.95 925.135 4531.23 C 920.545 4519.88 916.975 4508.1 912.865 4496.45",
      "id": "path230"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1376.195 4502.28 C 1371.525 4515.96 1368.795 4530.52 1368.905 4545.31 C 1369.035 4552.69 1369.985 4560.11 1371.835 4567.34 C 1373.765 4574.76 1376.245 4581.36 1377.885 4588.17 C 1384.665 4615.97 1390.565 4644.29 1396.525 4672.49 C 1402.655 4700.7 1408.535 4728.97 1415.065 4757.11 L 1424.785 4799.35 C 1428.355 4813.38 1431.565 4827.46 1435.365 4841.45 C 1432.025 4812.67 1427.445 4784.12 1422.605 4755.61 C 1417.845 4727.08 1412.225 4698.72 1406.305 4670.41 C 1400.065 4642.15 1393.945 4613.91 1385.245 4586.02 C 1383.025 4578.91 1379.975 4572.09 1377.885 4565.65 C 1375.705 4559 1374.435 4552.05 1373.765 4545.02 C 1372.045 4530.91 1373.685 4516.54 1376.195 4502.28",
      "id": "path232"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#c76043",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 727.815 5407.44 C 725.125 5408.54 722.375 5407.05 721.685 5404.26 C 718.375 5391 707.695 5366.86 697.725 5366.01 C 686.475 5365.06 688.685 5471.98 673.495 5475.1 C 667.375 5476.36 663.745 5400.31 663.745 5400.31 C 663.745 5400.31 652.275 5482.74 642.815 5477.6 C 633.355 5472.45 634.075 5398.7 634.075 5398.7 C 634.075 5398.7 612.795 5479.72 605.485 5470.49 C 598.175 5461.26 605.705 5396.44 605.705 5396.44 C 594.775 5425.17 586.245 5435.4 581.205 5439 C 578.815 5440.71 575.895 5439.22 575.945 5436.31 C 576.575 5400.75 611.945 5326.81 627.545 5295.86 L 627.495 5295.86 L 627.185 5295.86 C 624.185 5282.04 621.565 5268.17 619.125 5254.27 C 648.705 5258.78 678.105 5265.75 707.325 5273.85 C 704.915 5284.6 703.445 5291.28 703.025 5293.14 C 703.025 5293.16 703.025 5293.15 703.015 5293.17 C 727.125 5330.96 734.275 5367.15 737.615 5385.56 C 740.175 5399.72 733.115 5405.28 727.815 5407.44",
      "id": "path234"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 617.865 5273.95 L 710.365 5277.28 L 779.525 4976.45 C 779.525 4976.45 851.195 5143.12 937.025 5153.95 C 1022.865 5164.78 912.025 4777.28 912.025 4777.28 C 912.025 4777.28 822.025 4648.95 732.865 4670.62 C 643.695 4692.28 616.195 4852.28 612.025 4893.95 C 607.865 4935.62 617.865 5273.95 617.865 5273.95",
      "id": "path236"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 761.195 4943.12 C 764.715 4956.22 770.165 4968.49 776.145 4980.44 L 783.175 4994.45 L 785.155 4978.59 C 786.385 4968.75 787.295 4958.89 787.565 4948.95 C 787.765 4939.02 787.715 4929.06 786.195 4918.95 C 782.745 4928.57 780.745 4938.32 779.005 4948.11 C 777.325 4957.9 776.285 4967.76 775.575 4977.65 L 784.575 4975.79 C 777.785 4964.41 770.455 4953.34 761.195 4943.12",
      "id": "path238"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 872.865 4733.95 C 877.695 4751.18 885.275 4767.06 893.475 4782.59 C 901.945 4797.96 911.095 4813 922.865 4826.45 C 917.975 4809.07 910.445 4793.28 902.255 4777.82 C 893.785 4762.5 884.705 4747.56 872.865 4733.95",
      "id": "path240"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#c76043",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1354.125 5469.07 C 1348.695 5486.13 1330.495 5499.8 1312.345 5495.36 C 1320.385 5732.59 1122.625 5700.64 1122.625 5700.64 C 998.485 5689.87 984.325 5557.93 985.255 5490.74 C 981.235 5493.07 977.465 5494.82 975.365 5495.35 C 957.175 5499.88 938.905 5486.17 933.455 5469.07 C 929.115 5455.44 932.045 5440.05 939.835 5428.05 C 946.295 5418.08 956.795 5408.78 968.005 5404.51 C 970.565 5403.54 981.115 5401.74 989.665 5401.97 C 1008.875 5246.92 1149.365 5262.18 1149.365 5262.18 C 1271.155 5256.16 1302.785 5341.22 1309.885 5402.64 C 1314.425 5403.2 1318.185 5403.98 1319.575 5404.51 C 1330.785 5408.78 1341.285 5418.08 1347.755 5428.05 C 1355.535 5440.05 1358.475 5455.44 1354.125 5469.07",
      "id": "path242"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#c1473b",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1208.505 5409.82 C 1208.505 5387.88 1226.285 5370.09 1248.225 5370.09 C 1270.175 5370.09 1287.965 5387.88 1287.965 5409.82 C 1287.965 5431.77 1270.175 5449.55 1248.225 5449.55 C 1226.285 5449.55 1208.505 5431.77 1208.505 5409.82",
      "id": "path244"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#c1473b",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1010.755 5409.82 C 1010.755 5387.88 1028.545 5370.09 1050.485 5370.09 C 1072.425 5370.09 1090.225 5387.88 1090.225 5409.82 C 1090.225 5431.77 1072.425 5449.55 1050.485 5449.55 C 1028.545 5449.55 1010.755 5431.77 1010.755 5409.82",
      "id": "path246"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1187.575 5486.92 C 1187.575 5473.94 1192.715 5463.43 1199.045 5463.43 C 1205.385 5463.43 1210.525 5473.94 1210.525 5486.92 C 1210.525 5499.89 1205.385 5510.41 1199.045 5510.41 C 1192.715 5510.41 1187.575 5499.89 1187.575 5486.92",
      "id": "path248"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1222.465 5517.84 C 1220.535 5514.04 1217.985 5510.72 1214.705 5507.82 C 1211.465 5504.92 1207.335 5502.66 1202.705 5501.6 L 1202.505 5501.56 C 1200.225 5501.03 1197.945 5502.46 1197.415 5504.74 C 1196.895 5507.03 1198.315 5509.31 1200.605 5509.84 C 1200.975 5509.92 1201.365 5509.95 1201.725 5509.94 C 1208.145 5509.69 1215.275 5513.59 1220.125 5519.26 L 1220.215 5519.35 C 1220.695 5519.93 1221.565 5519.99 1222.145 5519.5 C 1222.635 5519.08 1222.755 5518.39 1222.465 5517.84",
      "id": "path250"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1111.145 5486.92 C 1111.145 5473.94 1106.015 5463.43 1099.675 5463.43 C 1093.335 5463.43 1088.195 5473.94 1088.195 5486.92 C 1088.195 5499.89 1093.335 5510.41 1099.675 5510.41 C 1106.015 5510.41 1111.145 5499.89 1111.145 5486.92",
      "id": "path252"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1078.595 5519.26 C 1083.455 5513.59 1090.585 5509.69 1096.995 5509.94 C 1099.345 5510.03 1101.315 5508.21 1101.415 5505.86 C 1101.505 5503.52 1099.675 5501.55 1097.335 5501.45 C 1096.955 5501.44 1096.585 5501.47 1096.235 5501.55 L 1096.025 5501.6 C 1091.385 5502.66 1087.255 5504.92 1084.015 5507.82 C 1080.735 5510.72 1078.195 5514.04 1076.245 5517.84 C 1075.905 5518.51 1076.165 5519.34 1076.845 5519.68 C 1077.415 5519.97 1078.115 5519.82 1078.515 5519.35 L 1078.595 5519.26",
      "id": "path254"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1192.435 5415.85 C 1188.465 5408.1 1182.405 5401.41 1175.145 5396.19 C 1167.895 5390.95 1158.815 5387.58 1149.455 5387.66 C 1140.165 5387.89 1131.045 5391.05 1123.895 5396.48 C 1120.145 5398.93 1117.215 5402.37 1113.985 5405.29 C 1111.285 5408.77 1108.645 5412.25 1106.285 5415.85 C 1109.835 5413.26 1113.055 5410.49 1116.305 5407.82 C 1119.915 5405.62 1123.145 5402.92 1126.805 5401.08 C 1133.935 5397.01 1141.725 5394.76 1149.485 5394.64 C 1157.305 5394.45 1165.085 5396.92 1172.275 5400.78 C 1179.435 5404.75 1186.175 5409.88 1192.435 5415.85",
      "id": "path256"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1161.445 5374.2 C 1158.175 5371.29 1153.685 5370.24 1149.365 5370.11 C 1145.025 5370.25 1140.605 5371.42 1137.285 5374.2 C 1141.525 5373.53 1145.375 5372.69 1149.375 5372.85 C 1153.355 5372.69 1157.265 5373.38 1161.445 5374.2",
      "id": "path258"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#370d1c",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1120.685 5568.39 C 1115.325 5573.14 1109.275 5574.69 1102.905 5574.97 C 1096.595 5575.12 1090.115 5574.38 1083.975 5572.29 C 1077.775 5570.39 1072.065 5566.91 1067.305 5562.73 C 1062.325 5558.71 1058.825 5553.39 1055.915 5548.14 C 1054.445 5545.49 1055.395 5542.15 1058.055 5540.68 C 1060.175 5539.5 1062.735 5539.88 1064.435 5541.43 L 1064.895 5541.86 C 1068.625 5545.3 1072.215 5548.52 1076.225 5550.86 C 1080.085 5553.46 1084.415 5554.88 1088.735 5555.99 C 1093.105 5557.01 1097.655 5557.55 1102.295 5557.31 C 1106.875 5557.16 1111.755 5556.92 1116.785 5558.15 L 1118.225 5558.5 C 1121.315 5559.26 1123.205 5562.37 1122.455 5565.45 C 1122.165 5566.63 1121.525 5567.64 1120.685 5568.39",
      "id": "path260"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#370d1c",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1178.035 5568.39 C 1183.385 5573.14 1189.445 5574.69 1195.815 5574.97 C 1202.125 5575.12 1208.615 5574.38 1214.755 5572.29 C 1220.945 5570.39 1226.655 5566.91 1231.425 5562.73 C 1236.405 5558.71 1239.895 5553.39 1242.805 5548.14 C 1244.275 5545.49 1243.325 5542.15 1240.675 5540.68 C 1238.555 5539.5 1235.985 5539.88 1234.295 5541.43 L 1233.825 5541.86 C 1230.095 5545.3 1226.505 5548.52 1222.495 5550.86 C 1218.635 5553.46 1214.315 5554.88 1209.985 5555.99 C 1205.625 5557.01 1201.075 5557.55 1196.435 5557.31 C 1191.855 5557.16 1186.965 5556.92 1181.945 5558.15 L 1180.485 5558.5 C 1177.395 5559.26 1175.515 5562.37 1176.265 5565.45 C 1176.555 5566.63 1177.195 5567.64 1178.035 5568.39",
      "id": "path262"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1152.015 5522.81 C 1154.045 5513.96 1155.545 5505.16 1157.185 5496.46 C 1158.885 5487.78 1160.475 5479.11 1162.945 5470.88 C 1163.525 5468.81 1164.155 5466.78 1164.895 5464.82 C 1165.495 5463.21 1166.935 5460.12 1166.895 5457.24 C 1167.185 5451.37 1163.435 5445.63 1158.645 5443.31 C 1153.765 5440.57 1148.125 5440.99 1143.675 5442.51 C 1139.155 5444.14 1135.225 5446.59 1131.815 5449.6 C 1140.055 5446.51 1149.675 5444.09 1155.475 5448.47 C 1158.385 5450.68 1159.955 5453.63 1159.535 5456.84 C 1159.395 5458.49 1158.875 5459.54 1157.815 5462.06 C 1156.935 5464.26 1156.155 5466.47 1155.495 5468.7 C 1152.985 5477.65 1151.685 5486.68 1151.185 5495.73 C 1150.665 5504.76 1150.835 5513.8 1152.015 5522.81",
      "id": "path264"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 947.845 5456.37 C 947.715 5461.76 949.205 5467.73 953.965 5471.91 C 959.025 5476.05 966.215 5475.67 971.685 5473.62 C 977.485 5471.61 982.245 5467.64 985.995 5463.18 C 989.835 5458.68 992.615 5453.79 994.885 5448.18 C 995.695 5446.18 994.735 5443.89 992.725 5443.08 C 991.215 5442.47 989.545 5442.87 988.465 5443.96 L 988.205 5444.23 C 984.395 5448.1 979.585 5452.24 975.055 5453.53 C 972.775 5454.12 971.105 5454.05 969.525 5452.92 C 967.895 5451.77 966.645 5449.33 965.585 5446.83 C 963.585 5441.68 962.365 5435.65 966.765 5433.27 C 971.375 5430.64 978.135 5431.28 984.155 5432.08 C 978.465 5429.58 972.185 5427.48 965.045 5429.52 C 961.425 5430.69 958.545 5434.81 958.305 5438.52 C 957.955 5442.24 958.495 5445.61 959.425 5448.92 C 960.395 5452.19 961.765 5455.66 964.975 5458.52 C 968.235 5461.44 973.355 5462.13 976.995 5461 C 984.435 5458.76 989.445 5454.47 994.115 5449.48 L 987.435 5445.53 C 983.845 5454.52 977.935 5463.88 969.405 5468.09 C 965.135 5470.14 960.085 5471.17 956.055 5468.9 C 951.825 5466.71 949.275 5461.53 947.845 5456.37",
      "id": "path266"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1344.865 5456.37 C 1344.985 5461.76 1343.505 5467.73 1338.735 5471.91 C 1333.675 5476.05 1326.485 5475.67 1321.015 5473.62 C 1315.215 5471.61 1310.455 5467.64 1306.705 5463.18 C 1302.865 5458.68 1300.085 5453.79 1297.815 5448.18 C 1296.995 5446.18 1297.975 5443.89 1299.975 5443.08 C 1301.495 5442.47 1303.165 5442.87 1304.235 5443.96 L 1304.495 5444.23 C 1308.305 5448.1 1313.115 5452.24 1317.645 5453.53 C 1319.915 5454.12 1321.595 5454.05 1323.175 5452.92 C 1324.805 5451.77 1326.055 5449.33 1327.115 5446.83 C 1329.115 5441.68 1330.325 5435.65 1325.935 5433.27 C 1321.325 5430.64 1314.565 5431.28 1308.555 5432.08 C 1314.235 5429.58 1320.515 5427.48 1327.655 5429.52 C 1331.275 5430.69 1334.155 5434.81 1334.395 5438.52 C 1334.745 5442.24 1334.215 5445.61 1333.275 5448.92 C 1332.305 5452.19 1330.935 5455.66 1327.725 5458.52 C 1324.455 5461.44 1319.345 5462.13 1315.695 5461 C 1308.265 5458.76 1303.245 5454.47 1298.585 5449.48 L 1305.265 5445.53 C 1308.855 5454.52 1314.765 5463.88 1323.295 5468.09 C 1327.565 5470.14 1332.615 5471.17 1336.655 5468.9 C 1340.875 5466.71 1343.425 5461.53 1344.865 5456.37",
      "id": "path268"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#370d1c",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 1436.525 5377.95 C 1439.835 5418.05 1414.125 5454.25 1388.325 5485.15 C 1362.635 5516.05 1334.235 5548.75 1330.435 5588.75 C 1328.325 5611.35 1334.435 5634.35 1330.035 5656.65 C 1322.825 5693.85 1288.435 5719.85 1253.225 5733.95 C 1199.335 5755.55 1137.635 5757.25 1082.535 5738.65 C 1027.535 5720.15 987.935 5669.45 950.435 5624.95 C 903.535 5569.25 888.225 5488.45 911.625 5419.35 C 920.035 5394.65 933.035 5371.25 937.935 5345.55 C 943.435 5316.35 938.135 5286.25 932.135 5257.15 C 926.225 5228.05 919.635 5198.35 922.635 5168.85 C 923.225 5162.75 924.335 5156.65 926.035 5150.65 C 932.735 5152.95 937.025 5153.95 937.025 5153.95 C 1010.325 5157.25 1051.225 5181.45 1051.225 5181.45 C 1051.225 5181.45 1052.135 5180.75 1053.935 5179.45 C 1055.535 5186.55 1057.135 5194.45 1058.535 5202.55 C 1061.935 5222.45 1062.935 5257.85 1061.525 5277.65 C 1061.525 5277.85 1061.525 5278.05 1061.435 5278.25 C 1061.335 5279.35 1061.125 5280.55 1060.935 5281.65 C 1028.535 5300.05 997.825 5335.25 989.525 5402.05 C 981.035 5401.75 970.535 5403.55 968.035 5404.55 C 956.835 5408.75 946.335 5418.05 939.835 5428.05 C 932.025 5440.05 929.125 5455.45 933.435 5469.05 C 938.935 5486.15 957.135 5499.85 975.325 5495.35 C 977.095 5494.85 980.075 5493.54 983.345 5491.78 C 984.965 5488.19 986.405 5484.53 988.185 5481.02 C 991.845 5473.79 997.215 5465.84 1005.295 5465.44 C 1013.505 5465.04 1019.645 5472.62 1023.915 5479.63 C 1033.895 5496.04 1041.745 5513.74 1047.205 5532.15 C 1051.295 5545.92 1054.055 5560.09 1058.725 5573.68 C 1063.395 5587.26 1070.205 5600.51 1080.945 5610.06 C 1095.185 5622.7 1117.375 5627.85 1135.745 5622.85 C 1131.945 5608.53 1137.345 5592.76 1147.405 5581.9 C 1157.485 5571.03 1171.645 5564.65 1186.125 5561.55 C 1200.625 5558.46 1215.565 5558.39 1230.375 5558.49 C 1243.515 5558.57 1258.445 5558.01 1267.065 5548.08 C 1274.075 5540.01 1274.515 5528.18 1273.165 5517.57 C 1271.815 5506.96 1269.035 5496.23 1270.975 5485.72 C 1272.315 5478.47 1277.455 5470.68 1284.825 5470.94 C 1289.875 5471.11 1293.925 5475 1297.435 5478.64 C 1302.865 5484.26 1308.285 5489.89 1313.715 5495.51 C 1331.385 5498.97 1348.865 5485.65 1354.125 5469.05 C 1358.435 5455.45 1355.535 5440.05 1347.735 5428.05 C 1341.335 5418.05 1330.825 5408.75 1319.525 5404.55 C 1318.135 5404.05 1314.435 5403.25 1309.835 5402.75 C 1305.035 5359.95 1288.135 5305.65 1237.135 5278.75 C 1236.125 5274.95 1235.435 5270.75 1235.035 5266.35 L 1235.035 5266.25 C 1233.225 5247.65 1235.825 5224.05 1239.525 5202.55 C 1241.125 5193.75 1242.825 5185.35 1244.435 5177.85 C 1245.825 5178.95 1247.335 5180.15 1248.725 5181.45 C 1248.725 5181.45 1304.525 5154.75 1334.525 5158.15 C 1348.135 5159.65 1373.225 5154.15 1397.425 5142.75 C 1397.335 5150.15 1396.435 5157.55 1395.235 5164.65 C 1390.435 5192.75 1380.635 5220.95 1384.635 5249.25 C 1391.125 5295.35 1432.825 5331.45 1436.525 5377.95",
      "id": "path270"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f1485b",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2636.845 5173.45 C 2636.845 5173.45 2605.185 5149.28 2571.845 5137.61 C 2538.515 5125.95 2415.185 5087.61 2403.515 5005.95 C 2391.845 4924.28 2357.685 4181.78 2357.685 4181.78 L 2577.685 4181.78 L 2660.185 5131.78 L 2636.845 5173.45",
      "id": "path272"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ee7b50",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2136.815 4584.6 C 2091.715 4607.04 2049.935 4610.86 2028.975 4612.46 C 2013.235 4613.66 2007.935 4605.81 2006.145 4600.14 C 2005.245 4597.25 2007.165 4594.57 2010.275 4594.14 C 2025.095 4592.08 2052.595 4583.52 2054.585 4573.33 C 2056.845 4561.83 1939.925 4553.25 1938.155 4537.26 C 1937.445 4530.84 2020.815 4534.82 2020.815 4534.82 C 2020.815 4534.82 1932.095 4514.61 1938.725 4505.39 C 1945.355 4496.17 2025.765 4504.4 2025.765 4504.4 C 2025.765 4504.4 1939.635 4474.23 1950.495 4467.63 C 1961.355 4461.03 2031.275 4475.4 2031.275 4475.4 C 2001.105 4461.2 1990.845 4451.37 1987.465 4445.81 C 1985.855 4443.17 1987.795 4440.31 1990.975 4440.66 C 2030.295 4444.99 2108.925 4490.24 2140.095 4508.98 C 2140.095 4508.97 2140.105 4508.97 2140.115 4508.96 C 2156.445 4499.89 2173.175 4491.4 2190.185 4483.35 L 2190.185 4587.49 C 2161.925 4585.95 2143.105 4584.95 2136.815 4584.6",
      "id": "path274"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f1485b",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2152.685 4589.7 C 2152.685 4589.7 2147.685 4480.95 2152.685 4469.7 C 2157.685 4458.45 2461.435 4372.2 2553.935 4409.7 C 2646.435 4447.2 2676.435 4843.45 2666.435 4912.2 C 2656.435 4980.95 2556.435 5099.7 2533.935 5099.7 C 2511.435 5099.7 2423.935 5079.7 2405.185 4997.2 C 2386.435 4914.7 2372.685 4598.45 2372.685 4598.45 L 2152.685 4589.7",
      "id": "path276"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ee7b50",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2278.585 2806.781 C 2276.855 2743.91 2275.485 2688.281 2274.485 2643.152 L 2389.345 2615.109 L 2451.825 2647.129 L 2484.695 2806.781 L 2278.585 2806.781",
      "id": "path278"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2271.675 2673.859 C 2271.675 2673.859 2237.055 2640.75 2206.945 2627.191 C 2176.845 2613.652 2041.375 2621.18 2050.405 2553.441 L 2363.495 2553.441 L 2391.345 2581.281 L 2391.345 2550.422 L 2453.805 2550.422 C 2453.805 2550.422 2477.885 2619.672 2455.305 2661.82 C 2455.305 2661.82 2410.155 2621.18 2360.485 2639.242 C 2310.805 2657.301 2271.675 2673.859 2271.675 2673.859",
      "id": "path280"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ee7b50",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2727.565 2806.781 L 2732.775 2653.109 L 2836.015 2608.441 L 2904.135 2651.121 C 2908.815 2693.75 2914.825 2746.68 2921.695 2806.781 L 2727.565 2806.781",
      "id": "path282"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2725.835 2673.859 C 2725.835 2673.859 2691.215 2640.75 2661.115 2627.191 C 2631.015 2613.652 2495.535 2621.18 2504.565 2553.441 L 2817.665 2553.441 L 2845.505 2581.281 L 2845.505 2550.422 L 2907.975 2550.422 C 2907.975 2550.422 2932.055 2619.672 2909.475 2661.82 C 2909.475 2661.82 2864.325 2621.18 2814.645 2639.242 C 2764.975 2657.301 2725.835 2673.859 2725.835 2673.859",
      "id": "path284"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2442.685 4395.95 L 3020.185 4395.95 C 3020.185 4395.95 3072.685 4170.94 3060.185 4005.94 C 3047.685 3840.94 2920.185 2695.941 2920.185 2695.941 L 2715.185 2695.941 L 2692.685 3868.44 L 2472.685 2705.941 L 2265.185 2705.941 C 2265.185 2705.941 2242.685 3985.94 2442.685 4395.95",
      "id": "path286"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2614.345 4383.45 L 2612.135 4321.68 L 2609.575 4259.95 L 2603.615 4136.52 L 2603.365 4138.22 L 2650.605 4008.43 C 2666.435 3965.19 2681.465 3921.67 2696.935 3878.3 L 2688.175 3876.78 C 2688.215 3926.78 2688.835 3976.78 2689.575 4026.78 C 2690.145 4076.78 2691.275 4126.78 2692.685 4176.78 C 2694.085 4126.78 2695.225 4076.78 2695.775 4026.78 C 2696.525 3976.78 2697.135 3926.78 2697.195 3876.78 L 2697.225 3850.93 L 2688.435 3875.26 C 2672.785 3918.56 2656.705 3961.7 2641.425 4005.13 L 2595.325 4135.34 L 2595.025 4136.2 L 2595.085 4137.03 L 2604.115 4260.28 L 2609.055 4321.87 L 2614.345 4383.45",
      "id": "path288"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 3001.015 4175.11 C 3007.395 4114.31 3012.015 4053.27 3011.695 3991.93 C 3011.505 3976.59 3010.205 3961.19 3008.915 3946.01 L 3005.115 3900.32 L 2997.515 3808.94 L 2965.555 3443.55 L 2931.295 3078.37 L 2913.345 2895.86 L 2894.345 2713.441 L 2908.465 2896.31 L 2923.635 3079.08 L 2955.615 3444.47 L 2989.885 3809.64 L 2998.855 3900.9 C 3001.535 3931.32 3005.575 3961.76 3006.835 3992.06 C 3008.795 4053 3005.155 4114.15 3001.015 4175.11",
      "id": "path290"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2644.345 4005.11 C 2628.745 3897.84 2612.055 3790.73 2595.215 3683.66 L 2543.445 3362.63 L 2489.395 3041.99 L 2461.555 2881.8 L 2432.685 2721.781 L 2456.715 2882.59 L 2481.805 3043.24 L 2533.595 3364.26 L 2587.655 3684.91 C 2606.085 3791.71 2624.675 3898.5 2644.345 4005.11",
      "id": "path292"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ee7b50",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2839.935 5095.49 C 2808.455 5175.19 2836.035 5341.77 2839.535 5362.33 C 2839.695 5363.05 2839.775 5363.69 2839.935 5364.4 L 2626.335 5244.29 C 2629.915 5238.31 2631.915 5230.18 2632.785 5220.78 L 2632.785 5220.7 C 2634.705 5201.65 2631.985 5177.42 2628.175 5155.35 C 2622.505 5123.07 2614.385 5095.49 2614.385 5095.49 L 2839.935 5095.49",
      "id": "path294"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#e86847",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2628.175 5155.35 C 2744.295 5140.68 2803.115 5279.36 2805.265 5284.54 C 2783.825 5250.51 2752.745 5233.29 2722.375 5225.09 C 2684.995 5214.88 2648.725 5218.31 2633.515 5220.54 C 2633.265 5220.62 2633.035 5220.62 2632.785 5220.7 C 2634.705 5201.65 2631.985 5177.42 2628.175 5155.35",
      "id": "path296"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2620.185 5153.45 C 2620.185 5153.45 2648.935 5097.2 2675.185 5100.95 C 2701.435 5104.7 2831.435 5173.45 2831.435 5173.45 C 2831.435 5173.45 2885.215 5133.3 2940.205 5130.25 C 2995.185 5127.2 3083.935 5080.95 3088.935 4944.7 C 3093.935 4808.45 3021.435 4540.95 3038.935 4437.2 C 3038.935 4437.2 3046.435 4399.7 3020.185 4395.95 L 2442.685 4395.95 C 2442.685 4395.95 2423.935 4417.2 2433.935 4442.2 C 2443.935 4467.2 2421.435 4769.7 2412.685 4839.7 C 2403.935 4909.7 2385.185 5027.2 2451.435 5063.45 C 2517.685 5099.7 2597.685 5117.2 2620.185 5153.45",
      "id": "path298"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2590.185 5119.7 C 2590.095 5107.78 2590.145 5095.91 2590.695 5084.24 C 2591.025 5078.42 2591.415 5072.59 2592.565 5067.22 C 2593.115 5064.52 2593.925 5062.06 2594.865 5060.24 C 2595.465 5059.73 2595.685 5059.18 2595.735 5059.39 C 2595.955 5059.27 2597.105 5059.31 2598.125 5059.43 C 2607.865 5061.26 2618.685 5067.52 2628.795 5072.8 C 2638.975 5078.49 2649.175 5084.45 2659.115 5090.59 L 2662.905 5092.92 L 2664.925 5089.34 C 2669.195 5081.79 2673.715 5074.21 2678.415 5066.84 C 2680.775 5063.17 2683.105 5059.44 2685.765 5056 C 2688.525 5052.68 2691.095 5048.96 2695.185 5047.2 C 2690.635 5047.83 2687.005 5051.18 2683.675 5054.07 C 2680.325 5057.1 2677.205 5060.35 2674.245 5063.71 C 2668.355 5070.51 2663.025 5077.62 2657.935 5085.05 L 2663.735 5083.8 C 2654.005 5076.75 2644.075 5070.17 2633.615 5064.23 C 2628.405 5061.2 2623.055 5058.39 2617.455 5055.91 C 2611.765 5053.53 2606.265 5050.9 2599.085 5050.16 C 2597.185 5050.1 2595.275 5049.92 2592.695 5050.86 C 2589.755 5051.89 2588.415 5054.14 2587.195 5055.9 C 2585.575 5059.43 2584.785 5062.72 2584.465 5065.88 C 2583.805 5072.22 2583.825 5078.28 2584.315 5084.31 C 2585.225 5096.33 2587.285 5108.11 2590.185 5119.7",
      "id": "path300"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2547.465 4470.31 L 1939.745 4470.31 L 1939.745 4868.82 L 2547.465 4868.82 L 2547.465 4470.31",
      "id": "path302"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2894.165 4470.31 L 1939.745 4470.31 L 1939.745 4438.43 L 2894.165 4438.43 L 2894.165 4470.31",
      "id": "path304"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2894.165 4470.31 L 2547.465 4470.31 L 2547.465 4438.43 L 2894.165 4438.43 L 2894.165 4470.31",
      "id": "path306"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2547.465 4470.31 L 2523.565 4470.31 L 2523.565 4868.82 L 2547.465 4868.82 L 2547.465 4470.31",
      "id": "path308"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ffffff",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2281.015 4671.78 C 2280.985 4684.46 2275.575 4696.98 2266.365 4705.46 C 2257.175 4713.98 2244.675 4718.25 2232.685 4717.6 C 2208.105 4716.66 2188.825 4694.6 2189.345 4671.78 C 2188.815 4648.96 2208.075 4626.85 2232.685 4625.93 C 2244.685 4625.29 2257.185 4629.56 2266.365 4638.09 C 2275.585 4646.58 2280.975 4659.1 2281.015 4671.78 L 2281.015 4671.78 Z M 2281.015 4671.78 C 2281.125 4659.11 2276.115 4646.48 2267.355 4637.11 C 2258.665 4627.65 2246.035 4621.51 2232.685 4620.96 C 2219.395 4620.3 2205.565 4625.13 2195.465 4634.57 C 2185.335 4643.96 2179.375 4657.8 2179.355 4671.78 C 2179.365 4685.75 2185.315 4699.61 2195.455 4709.01 C 2205.545 4718.47 2219.395 4723.28 2232.685 4722.63 C 2246.035 4722.06 2258.675 4715.93 2267.355 4706.45 C 2276.125 4697.07 2281.125 4684.45 2281.015 4671.78",
      "id": "path310"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f1485b",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2831.435 5173.45 C 2831.435 5173.45 2690.185 5080.95 2697.685 4978.45 C 2705.185 4875.95 2690.185 4183.44 2690.185 4183.44 L 3045.095 4183.44 C 3058.905 4183.44 3070.065 4194.66 3069.985 4208.47 C 3069.415 4304.81 3069.075 4650.84 3092.685 4740.95 C 3120.185 4845.95 3122.685 5048.45 3057.685 5095.95 C 2992.685 5143.45 2882.685 5140.95 2831.435 5173.45",
      "id": "path312"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2694.715 4434.85 C 2694.715 4434.85 3019.345 4456.78 3072.685 4471.78 L 2694.245 4399.54 L 2694.715 4434.85",
      "id": "path314"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2712.685 4228.44 C 2740.185 4230.51 2767.685 4231.48 2795.185 4232.27 C 2822.685 4233.19 2850.185 4233.31 2877.685 4233.44 C 2905.185 4233.33 2932.685 4233.2 2960.185 4232.29 L 3001.435 4230.89 C 3015.185 4230.06 3028.935 4229.58 3042.685 4228.44 C 3028.935 4227.31 3015.185 4226.83 3001.435 4225.99 L 2960.185 4224.6 C 2932.685 4223.7 2905.185 4223.56 2877.685 4223.45 C 2850.185 4223.58 2822.685 4223.7 2795.185 4224.61 C 2767.685 4225.41 2740.185 4226.38 2712.685 4228.44",
      "id": "path316"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#cc6450",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2628.405 4565.68 C 2611.345 4559.29 2599.955 4555.04 2595.465 4553.37 C 2594.025 4552.83 2593.265 4552.59 2593.265 4552.59 L 2619.925 4482.47 C 2619.925 4482.46 2619.935 4482.46 2619.945 4482.46 C 2627.065 4480.99 2634.245 4479.7 2641.425 4478.41 C 2636.895 4507.46 2632.675 4536.58 2628.405 4565.68",
      "id": "path318"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ee7b50",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2631.525 4493.92 C 2631.525 4493.92 2545.395 4392.48 2499.605 4372.34 C 2496.675 4371.05 2493.975 4373.2 2494.715 4376.2 C 2496.275 4382.52 2503.105 4394.97 2527.625 4417.57 C 2527.625 4417.57 2465.245 4382.88 2452.905 4385.92 C 2440.565 4388.96 2513.665 4443.59 2513.665 4443.59 C 2513.665 4443.59 2439.435 4411.6 2430.335 4418.4 C 2421.245 4425.21 2499.815 4471.11 2499.815 4471.11 C 2499.815 4471.11 2421.485 4442.29 2420.235 4448.64 C 2417.125 4464.42 2526.085 4507.69 2520.475 4517.99 C 2515.515 4527.1 2486.715 4527.02 2471.955 4524.54 C 2468.855 4524.02 2466.225 4525.99 2466.225 4529.02 C 2466.225 4534.97 2468.935 4544.05 2484.305 4547.63 C 2508.025 4553.14 2559.265 4564.27 2619.815 4548.36 L 2631.525 4493.92",
      "id": "path320"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#f1485b",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 3065.185 5085.95 C 3065.185 5085.95 3307.685 4733.45 3315.185 4648.45 C 3322.685 4563.45 3302.685 4513.45 3082.685 4473.45 C 2862.685 4433.45 2632.685 4433.45 2632.685 4433.45 L 2605.185 4575.95 L 2945.185 4708.45 C 2945.185 4708.45 2805.185 4913.45 2810.185 4958.45 C 2815.185 5003.45 3065.185 5085.95 3065.185 5085.95",
      "id": "path322"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2869.345 4880.11 C 2878.745 4866.14 2887.775 4851.94 2896.935 4837.83 C 2906.165 4823.75 2914.885 4809.37 2923.885 4795.16 C 2932.755 4780.87 2941.905 4766.74 2950.545 4752.32 L 2976.695 4709.17 L 2979.685 4704.25 L 2974.165 4702.35 C 2951.455 4694.53 2928.745 4686.65 2905.865 4679.32 L 2837.365 4656.91 C 2791.525 4642.49 2745.665 4628.12 2699.345 4615.11 C 2744.135 4632.66 2789.395 4648.84 2834.655 4664.98 L 2902.815 4688.41 C 2925.495 4696.35 2948.355 4703.75 2971.185 4711.21 L 2968.665 4704.39 L 2943.155 4747.91 C 2934.565 4762.37 2926.495 4777.13 2918.145 4791.73 C 2909.915 4806.41 2901.415 4820.92 2893.425 4835.74 C 2885.365 4850.51 2877.165 4865.2 2869.345 4880.11",
      "id": "path324"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 3007.685 4738.45 C 3004.485 4730.24 2999.255 4724.31 2993.535 4718.91 C 2987.605 4713.74 2981.165 4709.12 2972.685 4706.78 C 2975.855 4715 2981.095 4720.93 2986.835 4726.32 C 2992.775 4731.47 2999.195 4736.09 3007.685 4738.45",
      "id": "path326"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2839.345 4956.78 C 2835.215 4970.95 2833.565 4985.85 2833.845 5000.74 C 2834.065 5015.64 2836.505 5030.59 2841.085 5045 C 2846.005 5059.31 2853.635 5072.83 2863.805 5084.07 C 2873.815 5095.63 2887.425 5103.16 2901.015 5108.45 C 2889.135 5099.64 2878.085 5090.58 2869.805 5079.07 C 2861.585 5067.67 2854.995 5055.21 2850.555 5041.82 C 2846.115 5028.43 2843.375 5014.44 2841.605 5000.21 C 2840.045 4985.97 2839.045 4971.49 2839.345 4956.78",
      "id": "path328"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#ee7b50",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2899.195 5428.73 C 2893.605 5446.28 2874.865 5460.34 2856.195 5455.69 C 2854.905 5455.37 2852.905 5454.53 2850.695 5453.44 C 2853.225 5514.73 2844.275 5581.85 2801.675 5618.89 C 2710.025 5698.59 2578.515 5670.7 2550.625 5598.97 C 2518.725 5516.96 2517.095 5415.45 2518.165 5328.65 C 2518.305 5317.28 2518.645 5305.69 2522.445 5294.97 C 2537.015 5253.77 2595.755 5228.34 2635.435 5220.11 C 2686.485 5209.52 2737.765 5222.87 2777.815 5256.15 C 2809.575 5282.53 2830.125 5319.75 2838.875 5360.07 C 2847.975 5359.29 2860.855 5361.42 2863.745 5362.52 C 2875.255 5366.91 2886.025 5376.44 2892.655 5386.67 C 2900.635 5398.97 2903.635 5414.76 2899.195 5428.73",
      "id": "path330"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2584.865 5455.02 C 2584.865 5441.71 2579.585 5430.92 2573.095 5430.92 C 2566.585 5430.92 2561.325 5441.71 2561.325 5455.02 C 2561.325 5468.32 2566.585 5479.11 2573.095 5479.11 C 2579.585 5479.11 2584.865 5468.32 2584.865 5455.02",
      "id": "path332"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2663.245 5455.02 C 2663.245 5441.71 2668.525 5430.92 2675.015 5430.92 C 2681.525 5430.92 2686.785 5441.71 2686.785 5455.02 C 2686.785 5468.32 2681.525 5479.11 2675.015 5479.11 C 2668.525 5479.11 2663.245 5468.32 2663.245 5455.02",
      "id": "path334"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2579.865 5382.13 C 2583.955 5374.18 2590.165 5367.32 2597.615 5361.96 C 2605.045 5356.59 2614.365 5353.13 2623.955 5353.21 C 2633.485 5353.45 2642.845 5356.69 2650.175 5362.26 C 2654.025 5364.78 2657.025 5368.29 2660.335 5371.3 C 2663.105 5374.87 2665.805 5378.44 2668.235 5382.13 C 2664.595 5379.47 2661.285 5376.63 2657.955 5373.89 C 2654.255 5371.64 2650.945 5368.87 2647.195 5366.98 C 2639.875 5362.8 2631.895 5360.5 2623.925 5360.37 C 2615.915 5360.17 2607.935 5362.71 2600.565 5366.68 C 2593.205 5370.75 2586.295 5376 2579.865 5382.13",
      "id": "path336"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2611.655 5339.41 C 2615.015 5336.43 2619.615 5335.35 2624.045 5335.21 C 2628.505 5335.36 2633.035 5336.56 2636.455 5339.41 C 2632.095 5338.72 2628.145 5337.87 2624.035 5338.02 C 2619.945 5337.86 2615.945 5338.57 2611.655 5339.41",
      "id": "path338"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2653.465 5538.58 C 2658.955 5543.45 2665.175 5545.04 2671.695 5545.33 C 2678.175 5545.48 2684.825 5544.72 2691.115 5542.57 C 2697.475 5540.63 2703.325 5537.06 2708.215 5532.78 C 2713.325 5528.65 2716.915 5523.19 2719.895 5517.82 C 2721.405 5515.09 2720.425 5511.66 2717.705 5510.16 C 2715.535 5508.94 2712.895 5509.33 2711.155 5510.93 L 2710.685 5511.37 C 2706.855 5514.89 2703.185 5518.2 2699.055 5520.59 C 2695.115 5523.26 2690.675 5524.72 2686.225 5525.87 C 2681.755 5526.9 2677.085 5527.46 2672.335 5527.22 C 2667.635 5527.05 2662.635 5526.82 2657.465 5528.08 L 2655.985 5528.44 C 2652.815 5529.21 2650.875 5532.4 2651.645 5535.57 C 2651.945 5536.78 2652.595 5537.81 2653.465 5538.58",
      "id": "path340"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2594.645 5538.58 C 2589.155 5543.45 2582.935 5545.04 2576.405 5545.33 C 2569.935 5545.48 2563.285 5544.72 2556.985 5542.57 C 2550.635 5540.63 2544.775 5537.06 2539.885 5532.78 C 2534.785 5528.65 2531.195 5523.19 2528.205 5517.82 C 2526.705 5515.09 2527.685 5511.66 2530.405 5510.16 C 2532.575 5508.94 2535.215 5509.33 2536.945 5510.93 L 2537.415 5511.37 C 2541.255 5514.89 2544.925 5518.2 2549.045 5520.59 C 2552.995 5523.26 2557.435 5524.72 2561.885 5525.87 C 2566.355 5526.9 2571.015 5527.46 2575.775 5527.22 C 2580.475 5527.05 2585.475 5526.82 2590.645 5528.08 L 2592.125 5528.44 C 2595.285 5529.21 2597.235 5532.4 2596.465 5535.57 C 2596.155 5536.78 2595.515 5537.81 2594.645 5538.58",
      "id": "path342"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2600.295 5494.07 C 2598.215 5484.99 2596.685 5475.98 2595.005 5467.04 C 2593.255 5458.14 2591.625 5449.25 2589.085 5440.81 C 2588.505 5438.7 2587.845 5436.61 2587.095 5434.6 C 2586.485 5432.95 2585.005 5429.78 2585.045 5426.83 C 2584.745 5420.8 2588.595 5414.92 2593.495 5412.54 C 2598.515 5409.73 2604.295 5410.16 2608.855 5411.72 C 2613.495 5413.39 2617.525 5415.9 2621.025 5418.99 C 2612.575 5415.81 2602.705 5413.34 2596.755 5417.83 C 2593.775 5420.1 2592.155 5423.12 2592.585 5426.42 C 2592.745 5428.11 2593.265 5429.19 2594.355 5431.77 C 2595.265 5434.02 2596.055 5436.29 2596.735 5438.58 C 2599.315 5447.75 2600.645 5457.02 2601.145 5466.3 C 2601.695 5475.57 2601.515 5484.84 2600.295 5494.07",
      "id": "path344"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2885.425 5417.96 C 2885.565 5423.49 2884.025 5429.62 2879.145 5433.9 C 2873.965 5438.15 2866.575 5437.76 2860.975 5435.65 C 2855.025 5433.59 2850.145 5429.52 2846.295 5424.95 C 2842.365 5420.33 2839.505 5415.32 2837.175 5409.56 C 2836.345 5407.5 2837.345 5405.16 2839.395 5404.33 C 2840.945 5403.7 2842.655 5404.12 2843.765 5405.24 L 2844.025 5405.51 C 2847.945 5409.49 2852.865 5413.73 2857.515 5415.05 C 2859.855 5415.66 2861.565 5415.58 2863.195 5414.43 C 2864.865 5413.25 2866.135 5410.75 2867.235 5408.17 C 2869.285 5402.89 2870.525 5396.71 2866.015 5394.27 C 2861.295 5391.58 2854.365 5392.23 2848.195 5393.05 C 2854.025 5390.49 2860.465 5388.33 2867.775 5390.42 C 2871.495 5391.62 2874.445 5395.84 2874.695 5399.66 C 2875.055 5403.47 2874.505 5406.93 2873.555 5410.32 C 2872.545 5413.67 2871.145 5417.24 2867.845 5420.17 C 2864.505 5423.17 2859.265 5423.87 2855.525 5422.71 C 2847.895 5420.41 2842.755 5416.01 2837.965 5410.89 L 2844.825 5406.84 C 2848.505 5416.06 2854.565 5425.66 2863.315 5429.99 C 2867.695 5432.08 2872.865 5433.14 2877.005 5430.81 C 2881.345 5428.57 2883.965 5423.25 2885.425 5417.96",
      "id": "path346"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "#1a2241",
      "fill-opacity": "1",
      "fill-rule": "nonzero",
      "stroke": "none"
    },
    attrs: {
      "d": "M 2911.885 5471.35 C 2905.875 5516.55 2883.275 5563.94 2844.385 5587.65 C 2850.585 5620.25 2828.885 5653.25 2799.975 5669.45 C 2771.085 5685.65 2736.575 5688.05 2703.375 5687.15 C 2670.275 5686.24 2636.975 5682.35 2604.175 5687.24 C 2586.675 5689.95 2569.285 5695.05 2551.675 5692.95 C 2523.275 5689.65 2499.875 5667.75 2486.675 5642.35 C 2470.185 5610.65 2466.885 5572.35 2477.875 5538.34 C 2488.085 5506.55 2509.975 5478.15 2520.585 5447.24 C 2521.795 5465.05 2523.615 5482.82 2526.115 5500.37 C 2529.305 5501.32 2532.395 5503.02 2535.165 5504.87 C 2553.275 5516.96 2566.915 5535.4 2586.385 5545.17 C 2612.415 5558.24 2643.425 5553.4 2672.175 5548.71 C 2700.915 5544.01 2733.955 5540.43 2759.125 5555.09 C 2750.375 5523.86 2756.965 5488.71 2776.455 5462.77 C 2784.285 5452.34 2794.445 5442.52 2796.335 5429.61 C 2797.165 5423.97 2796.295 5418.22 2796.605 5412.53 C 2796.915 5406.84 2798.735 5400.74 2803.445 5397.52 C 2809.085 5393.67 2817.135 5395.39 2822.445 5399.7 C 2827.775 5404 2830.975 5410.31 2834.025 5416.42 C 2840.375 5429.12 2846.725 5441.81 2853.075 5454.5 C 2854.275 5455.03 2855.365 5455.46 2856.175 5455.65 C 2874.875 5460.35 2893.585 5446.24 2899.175 5428.74 C 2903.675 5414.74 2900.685 5398.94 2892.685 5386.64 C 2885.985 5376.44 2875.275 5366.95 2863.775 5362.55 C 2860.875 5361.44 2848.275 5359.25 2839.175 5360.05 C 2838.185 5354.14 2836.275 5342.35 2834.175 5326.75 C 2854.285 5344.54 2877.075 5360.25 2892.185 5382.15 C 2909.875 5407.75 2915.875 5440.45 2911.885 5471.35",
      "id": "path348"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }